import React, { useState, useEffect, useCallback, useRef } from 'react'
import { supabase } from '../supabaseClient'
import { security } from '../config/security'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import { PDFDocument } from 'pdf-lib'
import { buildContratoHtml, wrapContratoHtmlDocumento, nomeArquivoContrato } from '../utils/contratoTemplate'
import DocumentosCliente from './DocumentosCliente'
import NovaOrdemServicoModal from './NovaOrdemServicoModal'
import { saveAs } from 'file-saver'
import { enviarProcuracaoParaClicksign } from '../services/clicksignProcuracao'
import { baixarPdfAssinadoClicksign } from '../services/clicksignBaixarAssinado'
import Swal from 'sweetalert2'
import './ClientesII.css'

const ESTADOS = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO']
const EMPRESA_ID_LXP = '6563a4d2-828a-4d0f-bce7-964c73a11171'

const formatCPFDisplay = (cpf) => {
  if (!cpf) return '–'
  const s = String(cpf).replace(/\D/g, '')
  if (s.length !== 11) return cpf
  return `${s.slice(0, 3)}.${s.slice(3, 6)}.${s.slice(6, 9)}-${s.slice(9)}`
}

const formatCurrencyDisplay = (value) => {
  if (value == null || value === '') return 'R$ 0,00'
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(value))
}

/** Formata digitação de moeda (centavos) para exibição pt-BR. */
const formatCurrencyInput = (input) => {
  const digits = String(input || '').replace(/\D/g, '')
  if (!digits) return ''
  const value = Number(digits) / 100
  return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

/** Converte string monetária pt-BR em número. */
const parseCurrencyInput = (input) => {
  const normalized = String(input || '').replace(/\./g, '').replace(',', '.')
  const parsed = Number(normalized)
  return Number.isFinite(parsed) ? parsed : 0
}

/** Usuário administrativo desta empresa vê todos os clientes (todas as empresas), como o administrador na listagem. */
const EMPRESA_ID_VER_TODOS_CLIENTES_CAD = 'f0c6de5a-eaf9-4530-a6a7-28140091897d'

const CadastrarClientes = ({ onBack, userRole, userEmpresa, userId, permissoesMenusCache = {}, hasPermissoesCustomizadas = false }) => {
  const canExcluir = security.canAccessMenu(userRole, 'cadastrar_clientes', permissoesMenusCache, hasPermissoesCustomizadas)
  const [clientes, setClientes] = useState([])
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [editingCliente, setEditingCliente] = useState(null)
  const [saving, setSaving] = useState(false)
  const [searchCep, setSearchCep] = useState(false)
  const [msg, setMsg] = useState({ text: '', type: '' })
  const [formData, setFormData] = useState({
    nome_completo: '',
    telefone: '',
    cpf: '',
    rg: '',
    empresa_id: '',
    link_localizacao: '',
    foto_fachada: '',
    cep: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
    valor_total: ''
  })
  const [kitSolarData, setKitSolarData] = useState({
    marca_inversor: '',
    potencia_inversor: '',
    quantidade_inversor: '',
    marca_modulo: '',
    potencia_modulo: '',
    quantidade_modulo: ''
  })
  const [clienteParaDocumentos, setClienteParaDocumentos] = useState(null)
  const [showNovaOrdemModal, setShowNovaOrdemModal] = useState(false)
  const [clienteParaNovaOrdem, setClienteParaNovaOrdem] = useState(null)
  const [filtroNome, setFiltroNome] = useState('')
  const [filtroEmpresa, setFiltroEmpresa] = useState('')
  const [empresas, setEmpresas] = useState([])
  const [showEditarOpcoesModal, setShowEditarOpcoesModal] = useState(false)
  const [clienteParaEditarOpcoes, setClienteParaEditarOpcoes] = useState(null)
  const [showAtribuirDadosModal, setShowAtribuirDadosModal] = useState(false)
  const [clienteParaAtribuirDados, setClienteParaAtribuirDados] = useState(null)
  const [atribuirDadosForm, setAtribuirDadosForm] = useState({ cpf: '', rg: '' })
  const [savingAtribuirDados, setSavingAtribuirDados] = useState(false)
  const [fotoFachadaFile, setFotoFachadaFile] = useState(null)
  const [uploadingFotoFachada, setUploadingFotoFachada] = useState(false)
  const [showClienteInfoModal, setShowClienteInfoModal] = useState(false)
  const [clienteParaVisualizar, setClienteParaVisualizar] = useState(null)
  const [showClicksignModal, setShowClicksignModal] = useState(false)
  const [clienteClicksign, setClienteClicksign] = useState(null)
  const [clicksignSendVia, setClicksignSendVia] = useState('whatsapp')
  const [clicksignEmailInput, setClicksignEmailInput] = useState('')
  const [clicksignPhoneInput, setClicksignPhoneInput] = useState('')
  const [sendingClicksign, setSendingClicksign] = useState(false)
  const [clicksignResult, setClicksignResult] = useState(null)
  const [enviosProcuracaoPorCliente, setEnviosProcuracaoPorCliente] = useState({})
  const [clicksignModoEnvio, setClicksignModoEnvio] = useState('procuracao_contrato') // 'procuracao_contrato' | 'anexos'
  const [clicksignAnexos, setClicksignAnexos] = useState([])
  // Lista de signatários do documento (permite mais de uma pessoa assinar o mesmo contrato)
  const [clicksignSigners, setClicksignSigners] = useState([])
  const [assinaturaSucessoModal, setAssinaturaSucessoModal] = useState({ show: false, clienteNome: '' })
  const [baixandoAssinadoClienteId, setBaixandoAssinadoClienteId] = useState(null)
  /** Modal intermediário: escolher baixar (assinado) ou enviar/reenviar (pendente) */
  const [clicksignHubCliente, setClicksignHubCliente] = useState(null)
  const clicksignFileInputRef = useRef(null)
  const [showDocumentoLxpModal, setShowDocumentoLxpModal] = useState(false)
  const [clienteDocumentoLxp, setClienteDocumentoLxp] = useState(null)
  const [valorContratoLxpInput, setValorContratoLxpInput] = useState('')
  const [gerandoContratoLxp, setGerandoContratoLxp] = useState(false)
  const [showValorContratoLxpModal, setShowValorContratoLxpModal] = useState(false)
  // Geração de contrato em PDF/HTML (com logo da empresa) por cliente
  const [gerandoContratoPdfId, setGerandoContratoPdfId] = useState(null)
  const [clienteParaContrato, setClienteParaContrato] = useState(null)
  // Procuradores (outorgados da procuração)
  const [procuradores, setProcuradores] = useState([])

  const isAdmin = userRole === 'administrador'
  const isHomologador = userRole === 'homologador'
  const verClientesTodasEmpresas =
    isAdmin ||
    isHomologador ||
    (userRole === 'administrativo' && userEmpresa?.id === EMPRESA_ID_VER_TODOS_CLIENTES_CAD)

  const nomeEmpresaPorId = (empresaId) => {
    if (!empresaId) return '–'
    if (userEmpresa?.id === empresaId) return userEmpresa?.empresa || '–'
    const emp = empresas.find(e => e.id === empresaId)
    return emp?.empresa || '–'
  }

  const loadEmpresas = useCallback(async () => {
    if (!verClientesTodasEmpresas) return
    try {
      const { data, error } = await supabase
        .from('empresa')
        .select('id, empresa')
        .order('empresa')
      if (error) throw error
      setEmpresas(data || [])
    } catch (err) {
      console.error('Erro ao carregar empresas:', err)
    }
  }, [verClientesTodasEmpresas])

  const loadClientes = useCallback(async () => {
    if (!userEmpresa?.id && !isAdmin) {
      setClientes([])
      setLoading(false)
      return
    }
    try {
      setLoading(true)
      let query = supabase
        .from('clientes_cadastro')
        .select(`
          *,
          kit_solar_cliente (
            marca_inversor,
            potencia_inversor,
            quantidade_inversor,
            marca_modulo,
            potencia_modulo,
            quantidade_modulo
          )
        `)
        .eq('venda_hangsix', false)
        .order('data_cadastro', { ascending: false })
      if (!verClientesTodasEmpresas && userEmpresa?.id) {
        query = query.eq('empresa_id', userEmpresa.id)
      }
      const { data, error } = await query
      if (error) throw error
      setClientes(data || [])
    } catch (err) {
      console.error('Erro ao carregar clientes:', err)
      setMsg({ text: err.message || 'Erro ao carregar clientes.', type: 'error' })
      setClientes([])
    } finally {
      setLoading(false)
    }
  }, [userEmpresa?.id, isAdmin, verClientesTodasEmpresas])

  useEffect(() => {
    loadClientes()
  }, [loadClientes])

  const loadProcuracaoEnvios = useCallback(async () => {
    if (clientes.length === 0) {
      setEnviosProcuracaoPorCliente({})
      return
    }
    try {
      const ids = clientes.map(c => c.id)
      const { data, error } = await supabase
        .from('procuracao_clicksign_envios')
        .select('cliente_id, document_key, clicksign_document_id, signing_url, send_via, created_at, signed_at')
        .in('cliente_id', ids)
        .order('created_at', { ascending: false })
      if (error) throw error
      const latest = {}
      for (const row of data || []) {
        if (!latest[row.cliente_id]) latest[row.cliente_id] = row
      }
      setEnviosProcuracaoPorCliente(latest)
    } catch (err) {
      console.error('Erro ao carregar envios de procuração:', err)
      setEnviosProcuracaoPorCliente({})
    }
  }, [clientes])

  useEffect(() => {
    loadProcuracaoEnvios()
  }, [loadProcuracaoEnvios])

  const loadProcuradores = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('procuradores')
        .select('*')
        .eq('ativo', true)
        .order('nome_procurador', { ascending: true })
      if (error) throw error
      setProcuradores(data || [])
    } catch (err) {
      console.error('Erro ao carregar procuradores:', err)
      setProcuradores([])
    }
  }, [])

  useEffect(() => {
    loadProcuradores()
  }, [loadProcuradores])

  // Realtime: mostrar modal de confirmação quando o documento for assinado (webhook atualiza signed_at)
  useEffect(() => {
    const channel = supabase
      .channel('cadastrar-clientes-procuracao-clicksign-envios')
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'procuracao_clicksign_envios'
        },
        (payload) => {
          const newRow = payload?.new
          const oldRow = payload?.old
          if (newRow?.signed_at && !oldRow?.signed_at) {
            const clienteId = newRow.cliente_id
            const nome = clientes?.find(c => c.id === clienteId)?.nome_completo || 'Cliente'
            setAssinaturaSucessoModal({ show: true, clienteNome: nome })
          }
          loadProcuracaoEnvios()
        }
      )
      .subscribe()
    return () => {
      supabase.removeChannel(channel)
    }
  }, [loadProcuracaoEnvios, clientes])

  useEffect(() => {
    if (verClientesTodasEmpresas) loadEmpresas()
    else setFiltroEmpresa('')
  }, [verClientesTodasEmpresas, loadEmpresas])

  const showNotification = (text, type) => setMsg({ text, type })

  const resetForm = () => {
    setFormData({
      nome_completo: '',
      telefone: '',
      cpf: '',
      rg: '',
      empresa_id: userEmpresa?.id || '',
      link_localizacao: '',
      foto_fachada: '',
      cep: '',
      logradouro: '',
      numero: '',
      complemento: '',
      bairro: '',
      cidade: '',
      estado: '',
      valor_total: ''
    })
    setKitSolarData({
      marca_inversor: '',
      potencia_inversor: '',
      quantidade_inversor: '',
      marca_modulo: '',
      potencia_modulo: '',
      quantidade_modulo: ''
    })
    setEditingCliente(null)
    setShowForm(false)
    setFotoFachadaFile(null)
  }

  const handleFotoFachadaUpload = async (file) => {
    if (!file) return
    if (!file.type.startsWith('image/')) {
      showNotification('Por favor, selecione um arquivo de imagem.', 'error')
      return
    }
    const maxSize = 10 * 1024 * 1024 // 10MB
    if (file.size > maxSize) {
      showNotification('A imagem deve ter no máximo 10MB.', 'error')
      return
    }
    try {
      setUploadingFotoFachada(true)
      const clienteId = editingCliente?.id || `temp_${Date.now()}`
      const fileExt = file.name.split('.').pop()
      const timestamp = Date.now()
      const fileName = `${clienteId}/fachada_${timestamp}.${fileExt}`
      const { error: uploadError } = await supabase.storage
        .from('Fachadas')
        .upload(fileName, file, { cacheControl: '3600', upsert: false })
      if (uploadError) {
        if (uploadError.message.includes('Bucket not found')) {
          throw new Error('Bucket "Fachadas" não encontrado. Crie o bucket no Supabase Storage (Files > Buckets > Fachadas).')
        }
        throw uploadError
      }
      const { data: { publicUrl } } = supabase.storage.from('Fachadas').getPublicUrl(fileName)
      setFormData(prev => ({ ...prev, foto_fachada: publicUrl }))
      setFotoFachadaFile({ file, url: publicUrl, name: file.name })
      showNotification('Foto da fachada enviada com sucesso!', 'success')
    } catch (err) {
      console.error('Erro ao fazer upload da foto da fachada:', err)
      showNotification('Erro ao fazer upload: ' + (err.message || 'Tente novamente.'), 'error')
    } finally {
      setUploadingFotoFachada(false)
    }
  }

  const removerFotoFachada = () => {
    setFormData(prev => ({ ...prev, foto_fachada: '' }))
    setFotoFachadaFile(null)
    const input = document.getElementById('form-foto-fachada-input')
    if (input) input.value = ''
  }

  const openNew = () => {
    resetForm()
    setShowForm(true)
  }

  const openEdit = async (cliente) => {
    setEditingCliente(cliente)
    setFotoFachadaFile(null)
    const valorTotalFormatado =
      cliente.valor_total != null && cliente.valor_total !== ''
        ? Number(cliente.valor_total).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : ''
    setFormData({
      nome_completo: cliente.nome_completo || '',
      telefone: cliente.telefone || '',
      cpf: (cliente.cpf || '').replace(/\D/g, ''),
      rg: cliente.rg || '',
      empresa_id: cliente.empresa_id || userEmpresa?.id || '',
      link_localizacao: cliente.link_localizacao || '',
      foto_fachada: cliente.foto_fachada || '',
      cep: (cliente.cep || '').replace(/\D/g, ''),
      logradouro: cliente.logradouro || '',
      numero: cliente.numero || '',
      complemento: cliente.complemento || '',
      bairro: cliente.bairro || '',
      cidade: cliente.cidade || '',
      estado: cliente.estado || '',
      valor_total: valorTotalFormatado
    })
    const kitFromCliente = Array.isArray(cliente.kit_solar_cliente) ? cliente.kit_solar_cliente[0] : cliente.kit_solar_cliente
    const kitInicial = kitFromCliente && typeof kitFromCliente === 'object' ? {
      marca_inversor: kitFromCliente.marca_inversor ?? '',
      potencia_inversor: kitFromCliente.potencia_inversor ?? '',
      quantidade_inversor: kitFromCliente.quantidade_inversor ?? '',
      marca_modulo: kitFromCliente.marca_modulo ?? '',
      potencia_modulo: kitFromCliente.potencia_modulo ?? '',
      quantidade_modulo: kitFromCliente.quantidade_modulo ?? ''
    } : {
      marca_inversor: '',
      potencia_inversor: '',
      quantidade_inversor: '',
      marca_modulo: '',
      potencia_modulo: '',
      quantidade_modulo: ''
    }
    setKitSolarData(kitInicial)
    setShowForm(true)
    if (!kitFromCliente) {
      try {
        const { data: kitRows } = await supabase
          .from('kit_solar_cliente')
          .select('marca_inversor, potencia_inversor, quantidade_inversor, marca_modulo, potencia_modulo, quantidade_modulo')
          .eq('id_cliente', cliente.id)
          .limit(1)
        const k = kitRows?.[0]
        if (k) {
          setKitSolarData({
            marca_inversor: k.marca_inversor ?? '',
            potencia_inversor: k.potencia_inversor ?? '',
            quantidade_inversor: k.quantidade_inversor ?? '',
            marca_modulo: k.marca_modulo ?? '',
            potencia_modulo: k.potencia_modulo ?? '',
            quantidade_modulo: k.quantidade_modulo ?? ''
          })
        }
      } catch (err) {
        console.error('Erro ao carregar Kit Solar:', err)
      }
    }
  }

  const buscarCep = async () => {
    const cep = (formData.cep || '').replace(/\D/g, '')
    if (cep.length !== 8) {
      showNotification('CEP inválido. Digite 8 dígitos.', 'error')
      return
    }
    try {
      setSearchCep(true)
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
      const data = await response.json()
      if (data.erro) {
        showNotification('CEP não encontrado.', 'error')
        return
      }
      setFormData(prev => ({
        ...prev,
        logradouro: data.logradouro || '',
        bairro: data.bairro || '',
        cidade: data.localidade || '',
        estado: data.uf || ''
      }))
      showNotification('Endereço encontrado!', 'success')
    } catch (error) {
      showNotification('Erro ao buscar CEP.', 'error')
    } finally {
      setSearchCep(false)
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    if (name === 'cep') {
      const apenasNumeros = (value || '').replace(/\D/g, '')
      setFormData(prev => ({ ...prev, [name]: apenasNumeros }))
      return
    }
    if (name === 'cpf') {
      const apenasNumeros = (value || '').replace(/\D/g, '').slice(0, 11)
      setFormData(prev => ({ ...prev, [name]: apenasNumeros }))
      return
    }
    if (name === 'valor_total') {
      setFormData(prev => ({ ...prev, valor_total: formatCurrencyInput(value) }))
      return
    }
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleKitSolarInputChange = (e) => {
    const { name, value } = e.target
    setKitSolarData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!formData.nome_completo?.trim()) {
      showNotification('Nome completo é obrigatório.', 'error')
      return
    }
    const empresaId = verClientesTodasEmpresas ? (formData.empresa_id || userEmpresa?.id) : userEmpresa?.id
    if (!empresaId) {
      showNotification('Empresa do usuário não identificada.', 'error')
      return
    }
    setSaving(true)
    setMsg({ text: '', type: '' })
    try {
      const cpfDigits = (formData.cpf || '').replace(/\D/g, '')
      const cpfValido = cpfDigits.length === 11 ? cpfDigits : null
      const valorTotalInformado = String(formData.valor_total || '').trim()
      const valorTotalNumero = valorTotalInformado ? parseCurrencyInput(valorTotalInformado) : 0
      const payload = {
        nome_completo: formData.nome_completo.trim(),
        telefone: formData.telefone?.trim() || null,
        cpf: editingCliente ? (cpfValido || editingCliente.cpf) : (cpfValido || `TEMP${Date.now().toString().slice(-8)}${Math.floor(Math.random() * 100).toString().padStart(2, '0')}`.slice(0, 11)),
        rg: (formData.rg || '').trim() || null,
        link_localizacao: (formData.link_localizacao || '').trim() || null,
        foto_fachada: (formData.foto_fachada || '').trim() || null,
        cep: (formData.cep || '').replace(/\D/g, '') || null,
        logradouro: formData.logradouro?.trim() || null,
        numero: formData.numero?.trim() || null,
        complemento: formData.complemento?.trim() || null,
        bairro: formData.bairro?.trim() || null,
        cidade: formData.cidade?.trim() || null,
        estado: formData.estado?.trim() || null,
        empresa_id: empresaId,
        venda_hangsix: false,
        // Na edição, preservar status/pagamento já salvos; no cadastro novo, usar padrões
        ativo: editingCliente ? (editingCliente.ativo !== false) : true,
        tipo_pagamento: editingCliente?.tipo_pagamento || 'avista',
        valor_total: valorTotalNumero
      }
      let clienteId = editingCliente?.id
      if (editingCliente) {
        const { error } = await supabase
          .from('clientes_cadastro')
          .update(payload)
          .eq('id', editingCliente.id)
        if (error) throw error
        showNotification('Cliente atualizado com sucesso.', 'success')
      } else {
        const { data: inserted, error } = await supabase.from('clientes_cadastro').insert([payload]).select('id')
        if (error) throw error
        clienteId = inserted?.[0]?.id
        showNotification('Cliente cadastrado com sucesso.', 'success')

        if (fotoFachadaFile?.file && (formData.foto_fachada || '').includes('/temp_')) {
          try {
            const fileExt = fotoFachadaFile.file.name.split('.').pop()
            const timestamp = Date.now()
            const fileName = `${clienteId}/fachada_${timestamp}.${fileExt}`
            const { error: uploadError } = await supabase.storage
              .from('Fachadas')
              .upload(fileName, fotoFachadaFile.file, { cacheControl: '3600', upsert: false })
            if (!uploadError) {
              const { data: { publicUrl } } = supabase.storage.from('Fachadas').getPublicUrl(fileName)
              await supabase.from('clientes_cadastro').update({ foto_fachada: publicUrl }).eq('id', clienteId)
            }
          } catch (reupErr) {
            console.error('Erro ao reenviar foto da fachada com ID do cliente:', reupErr)
          }
        }
      }

      const hasKitSolarData = (
        (kitSolarData.marca_inversor && kitSolarData.marca_inversor.trim() !== '') ||
        (kitSolarData.potencia_inversor !== '' && kitSolarData.potencia_inversor != null) ||
        (kitSolarData.quantidade_inversor !== '' && kitSolarData.quantidade_inversor != null) ||
        (kitSolarData.marca_modulo && kitSolarData.marca_modulo.trim() !== '') ||
        (kitSolarData.potencia_modulo !== '' && kitSolarData.potencia_modulo != null) ||
        (kitSolarData.quantidade_modulo !== '' && kitSolarData.quantidade_modulo != null)
      )
      if (hasKitSolarData && clienteId && empresaId) {
        const kitPayload = {
          id_empresa: empresaId,
          marca_inversor: kitSolarData.marca_inversor?.trim() || null,
          potencia_inversor: (kitSolarData.potencia_inversor !== '' && kitSolarData.potencia_inversor != null) ? parseFloat(kitSolarData.potencia_inversor) : null,
          quantidade_inversor: (kitSolarData.quantidade_inversor !== '' && kitSolarData.quantidade_inversor != null) ? parseInt(kitSolarData.quantidade_inversor, 10) : null,
          marca_modulo: kitSolarData.marca_modulo?.trim() || null,
          potencia_modulo: (kitSolarData.potencia_modulo !== '' && kitSolarData.potencia_modulo != null) ? parseFloat(kitSolarData.potencia_modulo) : null,
          quantidade_modulo: (kitSolarData.quantidade_modulo !== '' && kitSolarData.quantidade_modulo != null) ? parseInt(kitSolarData.quantidade_modulo, 10) : null
        }
        const { data: existingKit, error: existingError } = await supabase
          .from('kit_solar_cliente')
          .select('id')
          .eq('id_cliente', clienteId)
          .maybeSingle()
        if (existingError) {
          console.error('Erro ao verificar kit solar:', existingError)
          showNotification('Erro ao salvar kit solar: ' + (existingError.message || ''), 'error')
        } else if (existingKit) {
          const { error: updateError } = await supabase
            .from('kit_solar_cliente')
            .update({ ...kitPayload, updated_by: userId || null })
            .eq('id_cliente', clienteId)
          if (updateError) {
            console.error('Erro ao atualizar kit solar:', updateError)
            showNotification('Erro ao atualizar kit solar: ' + (updateError.message || ''), 'error')
          }
        } else {
          const createdBy = userId || null
          const { error: insertError } = await supabase
            .from('kit_solar_cliente')
            .insert([{ id_cliente: clienteId, ...kitPayload, created_by: createdBy, updated_by: createdBy }])
          if (insertError) {
            console.error('Erro ao inserir kit solar:', insertError)
            showNotification('Erro ao salvar kit solar: ' + (insertError.message || ''), 'error')
          }
        }
      }

      resetForm()
      loadClientes()
    } catch (err) {
      showNotification(err.message || 'Erro ao salvar.', 'error')
    } finally {
      setSaving(false)
    }
  }

  const openEditarOpcoes = (cliente) => {
    setClienteParaEditarOpcoes(cliente)
    setShowEditarOpcoesModal(true)
  }

  const escolherEditarCliente = () => {
    if (clienteParaEditarOpcoes) openEdit(clienteParaEditarOpcoes)
    setShowEditarOpcoesModal(false)
    setClienteParaEditarOpcoes(null)
  }

  const escolherAtribuirDados = () => {
    if (!clienteParaEditarOpcoes) return
    setClienteParaAtribuirDados(clienteParaEditarOpcoes)
    const cpfRaw = (clienteParaEditarOpcoes.cpf || '').replace(/\D/g, '')
    setAtribuirDadosForm({
      cpf: cpfRaw,
      rg: clienteParaEditarOpcoes.rg || ''
    })
    setShowEditarOpcoesModal(false)
    setClienteParaEditarOpcoes(null)
    setShowAtribuirDadosModal(true)
  }

  const handleAtribuirDadosSubmit = async (e) => {
    e.preventDefault()
    if (!clienteParaAtribuirDados?.id) return
    const cpfDigits = (atribuirDadosForm.cpf || '').replace(/\D/g, '')
    if (cpfDigits.length !== 11) {
      showNotification('CPF deve ter 11 dígitos.', 'error')
      return
    }
    setSavingAtribuirDados(true)
    setMsg({ text: '', type: '' })
    try {
      const { error } = await supabase
        .from('clientes_cadastro')
        .update({
          cpf: cpfDigits,
          rg: (atribuirDadosForm.rg || '').trim() || null
        })
        .eq('id', clienteParaAtribuirDados.id)
      if (error) throw error
      showNotification('CPF e RG atualizados com sucesso.', 'success')
      setShowAtribuirDadosModal(false)
      setClienteParaAtribuirDados(null)
      setAtribuirDadosForm({ cpf: '', rg: '' })
      loadClientes()
    } catch (err) {
      showNotification(err.message || 'Erro ao salvar.', 'error')
    } finally {
      setSavingAtribuirDados(false)
    }
  }

  const handleDelete = async (cliente) => {
    if (!window.confirm(`Excluir o cliente "${cliente.nome_completo}"?`)) return
    try {
      setLoading(true)
      const { error } = await supabase.from('clientes_cadastro').delete().eq('id', cliente.id)
      if (error) throw error
      showNotification('Cliente excluído.', 'success')
      loadClientes()
    } catch (err) {
      showNotification(err.message || 'Erro ao excluir.', 'error')
    } finally {
      setLoading(false)
    }
  }

  if (!userEmpresa?.id) {
    return (
      <div className="clientes-ii-container" style={{ padding: '2rem' }}>
        <button type="button" className="btn-back" onClick={onBack}>Voltar</button>
        <h2>📝 Cadastrar Clientes</h2>
        <p className="text-muted">É necessário estar vinculado a uma empresa para usar esta tela.</p>
      </div>
    )
  }

  if (showForm) {
    return (
      <div className="clientes-ii-container" style={{ padding: '1.5rem' }}>
        <div className="clientes-ii-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
          <h2>{editingCliente ? 'Editar cliente' : 'Cadastrar Cliente'}</h2>
          <button type="button" className="btn-back" onClick={resetForm}>Voltar</button>
        </div>
        <form onSubmit={handleSubmit} className="cliente-form">
          <div className="form-section">
            <h3 className="section-title">👤 Dados</h3>
            <div className="row">
              <div className="col-12 mb-3">
                <label htmlFor="nome_completo" className="form-label">Nome completo *</label>
                <input type="text" className="form-control" id="nome_completo" name="nome_completo" value={formData.nome_completo} onChange={handleInputChange} required placeholder="Nome completo" />
              </div>
              <div className="col-12 col-md-6 mb-3">
                <label htmlFor="telefone" className="form-label">Telefone</label>
                <input type="tel" className="form-control" id="telefone" name="telefone" value={formData.telefone} onChange={handleInputChange} placeholder="(00) 00000-0000" />
              </div>
              <div className="col-12 col-md-6 mb-3">
                <label htmlFor="form-cpf" className="form-label">CPF</label>
                <input type="text" className="form-control" id="form-cpf" name="cpf" value={formData.cpf} onChange={handleInputChange} placeholder="Somente números (11 dígitos)" maxLength={11} />
              </div>
              <div className="col-12 col-md-6 mb-3">
                <label htmlFor="form-rg" className="form-label">RG</label>
                <input type="text" className="form-control" id="form-rg" name="rg" value={formData.rg} onChange={handleInputChange} placeholder="Número do RG" />
              </div>
              <div className="col-12 col-md-6 mb-3">
                <label htmlFor="form-valor-total" className="form-label">Valor total <span className="text-muted">(opcional)</span></label>
                <input
                  type="text"
                  className="form-control"
                  id="form-valor-total"
                  name="valor_total"
                  value={formData.valor_total}
                  onChange={handleInputChange}
                  placeholder="R$ 0,00"
                  inputMode="numeric"
                />
                <small className="text-muted" style={{ display: 'block', marginTop: '0.25rem' }}>
                  Valor salvo na coluna valor_total. Não é obrigatório.
                </small>
              </div>
              <div className="col-12 col-md-6 mb-3">
                <label htmlFor="form-empresa" className="form-label">Empresa</label>
                <select
                  id="form-empresa"
                  className="form-control"
                  value={formData.empresa_id}
                  onChange={(e) => setFormData(prev => ({ ...prev, empresa_id: e.target.value }))}
                  disabled={!verClientesTodasEmpresas}
                  style={!verClientesTodasEmpresas ? { cursor: 'not-allowed', opacity: 0.9 } : {}}
                >
                  {verClientesTodasEmpresas ? (
                    (empresas.length > 0 ? empresas : (userEmpresa ? [userEmpresa] : [])).map(emp => (
                      <option key={emp.id} value={emp.id}>{emp.empresa}</option>
                    ))
                  ) : (
                    userEmpresa && <option value={userEmpresa.id}>{userEmpresa.empresa}</option>
                  )}
                </select>
                {!verClientesTodasEmpresas && <small className="text-muted" style={{ display: 'block', marginTop: '0.25rem' }}>Vinculado à sua empresa</small>}
              </div>
              <div className="col-12 mb-3">
                <label htmlFor="form-link-localizacao" className="form-label">🔗 Link da localização <span className="text-muted">(opcional)</span></label>
                <input
                  type="url"
                  className="form-control"
                  id="form-link-localizacao"
                  name="link_localizacao"
                  value={formData.link_localizacao}
                  onChange={handleInputChange}
                  placeholder="Ex: link do Google Maps do local da instalação"
                />
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">📷 Foto da fachada <span className="text-muted">(opcional)</span></label>
                <input
                  type="file"
                  id="form-foto-fachada-input"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    const file = e.target.files?.[0]
                    if (file) handleFotoFachadaUpload(file)
                    e.target.value = ''
                  }}
                />
                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '0.75rem' }}>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => document.getElementById('form-foto-fachada-input')?.click()}
                    disabled={uploadingFotoFachada}
                  >
                    {uploadingFotoFachada ? '⏳ Enviando...' : '📷 Anexar foto da fachada'}
                  </button>
                  {(formData.foto_fachada || fotoFachadaFile?.url) && (
                    <>
                      <div style={{ flex: '0 0 auto' }}>
                        <img
                          src={formData.foto_fachada || fotoFachadaFile?.url}
                          alt="Foto da fachada"
                          style={{ maxWidth: '120px', maxHeight: '90px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #dee2e6' }}
                          onError={(e) => { e.target.style.display = 'none' }}
                        />
                      </div>
                      <button type="button" className="btn btn-sm btn-outline-danger" onClick={removerFotoFachada}>
                        Remover
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="form-section">
            <h3 className="section-title">📍 Endereço</h3>
            <div className="row">
              <div className="col-12 col-md-6 mb-3">
                <label htmlFor="cep" className="form-label">CEP</label>
                <div className="input-with-button">
                  <input type="text" className="form-control" id="cep" name="cep" value={formData.cep} onChange={handleInputChange} placeholder="00000-000" maxLength="9" />
                  <button type="button" onClick={buscarCep} disabled={searchCep} className="btn-search-cep">{searchCep ? '🔄' : '🔍'}</button>
                </div>
              </div>
              <div className="col-12 col-md-6 mb-3">
                <label htmlFor="estado" className="form-label">Estado</label>
                <select className="form-control" id="estado" name="estado" value={formData.estado} onChange={handleInputChange}>
                  <option value="">Selecione</option>
                  {ESTADOS.map(uf => <option key={uf} value={uf}>{uf}</option>)}
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-8 mb-3">
                <label htmlFor="logradouro" className="form-label">Logradouro</label>
                <input type="text" className="form-control" id="logradouro" name="logradouro" value={formData.logradouro} onChange={handleInputChange} placeholder="Rua, Avenida" />
              </div>
              <div className="col-12 col-md-4 mb-3">
                <label htmlFor="numero" className="form-label">Número</label>
                <input type="text" className="form-control" id="numero" name="numero" value={formData.numero} onChange={handleInputChange} placeholder="Nº" />
              </div>
            </div>
            <div className="row">
              <div className="col-12 mb-3">
                <label htmlFor="complemento" className="form-label">Complemento</label>
                <input type="text" className="form-control" id="complemento" name="complemento" value={formData.complemento} onChange={handleInputChange} placeholder="Apto, Bloco" />
              </div>
              <div className="col-12 col-md-6 mb-3">
                <label htmlFor="bairro" className="form-label">Bairro</label>
                <input type="text" className="form-control" id="bairro" name="bairro" value={formData.bairro} onChange={handleInputChange} placeholder="Bairro" />
              </div>
              <div className="col-12 col-md-6 mb-3">
                <label htmlFor="cidade" className="form-label">Cidade</label>
                <input type="text" className="form-control" id="cidade" name="cidade" value={formData.cidade} onChange={handleInputChange} placeholder="Cidade" />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3 className="section-title">☀️ Kit Solar</h3>
            <div className="row">
              <div className="col-12 col-md-4 mb-3">
                <label htmlFor="marca_inversor" className="form-label">Marca do Inversor</label>
                <input type="text" className="form-control" id="marca_inversor" name="marca_inversor" value={kitSolarData.marca_inversor} onChange={handleKitSolarInputChange} placeholder="Ex: Growatt, Huawei, Fronius" />
              </div>
              <div className="col-12 col-md-4 mb-3">
                <label htmlFor="potencia_inversor" className="form-label">Potência do Inversor (kW)</label>
                <input type="number" className="form-control" id="potencia_inversor" name="potencia_inversor" value={kitSolarData.potencia_inversor} onChange={handleKitSolarInputChange} step="0.1" min="0" placeholder="Ex: 5.0" />
              </div>
              <div className="col-12 col-md-4 mb-3">
                <label htmlFor="quantidade_inversor" className="form-label">Quantidade de Inversor</label>
                <input type="number" className="form-control" id="quantidade_inversor" name="quantidade_inversor" value={kitSolarData.quantidade_inversor} onChange={handleKitSolarInputChange} min="1" placeholder="Ex: 1" />
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-4 mb-3">
                <label htmlFor="marca_modulo" className="form-label">Marca do Módulo</label>
                <input type="text" className="form-control" id="marca_modulo" name="marca_modulo" value={kitSolarData.marca_modulo} onChange={handleKitSolarInputChange} placeholder="Ex: Canadian Solar, Jinko, Trina" />
              </div>
              <div className="col-12 col-md-4 mb-3">
                <label htmlFor="potencia_modulo" className="form-label">Potência do Módulo (W)</label>
                <input type="number" className="form-control" id="potencia_modulo" name="potencia_modulo" value={kitSolarData.potencia_modulo} onChange={handleKitSolarInputChange} min="0" placeholder="Ex: 550" />
              </div>
              <div className="col-12 col-md-4 mb-3">
                <label htmlFor="quantidade_modulo" className="form-label">Quantidade de Módulo</label>
                <input type="number" className="form-control" id="quantidade_modulo" name="quantidade_modulo" value={kitSolarData.quantidade_modulo} onChange={handleKitSolarInputChange} min="1" placeholder="Ex: 10" />
              </div>
            </div>
          </div>

          <div className="form-actions" style={{ display: 'flex', gap: '0.75rem', marginTop: '1.5rem' }}>
            <button type="button" className="btn btn-secondary" onClick={resetForm}>Cancelar</button>
            <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Salvando...' : 'Salvar'}</button>
          </div>
        </form>
      {msg.text && (
        <div className="form-overlay" onClick={() => setMsg({ text: '', type: '' })}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px' }}>
            <div className="modal-header">
              <h3>{msg.type === 'success' ? 'Sucesso' : msg.type === 'error' ? 'Erro' : 'Aviso'}</h3>
              <button type="button" className="close-button" onClick={() => setMsg({ text: '', type: '' })}>×</button>
            </div>
            <p style={{ padding: '1rem', margin: 0 }}>{msg.text}</p>
            <div style={{ padding: '0 1rem 1rem', textAlign: 'right' }}>
              <button type="button" className="btn btn-primary" onClick={() => setMsg({ text: '', type: '' })}>OK</button>
            </div>
          </div>
        </div>
      )}
    </div>
    )
  }

  const formatarEndereco = (cliente) => {
    const partes = []
    if (cliente.logradouro) partes.push(cliente.logradouro)
    if (cliente.numero) partes.push(`N° ${cliente.numero}`)
    if (cliente.complemento) partes.push(cliente.complemento)
    if (cliente.bairro) partes.push(`Bairro: ${cliente.bairro}`)
    if (cliente.cep) partes.push(`CEP: ${cliente.cep}`)
    if (cliente.cidade) partes.push(`Cidade: ${cliente.cidade}`)
    if (cliente.estado) partes.push(`${cliente.estado}`)
    return partes.length > 0 ? partes.join(', ') : 'Endereço não informado'
  }

  const formatarDataExtenso = (data = new Date()) => {
    const meses = [
      'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
      'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
    ]
    return `${data.getDate()} de ${meses[data.getMonth()]} de ${data.getFullYear()}`
  }

  const getPotenciaKwpCliente = (cliente) => {
    const kitRel = cliente?.kit_solar_cliente
    const kit = Array.isArray(kitRel) ? kitRel[0] : kitRel
    const potenciaModulo = Number(kit?.potencia_modulo || cliente?.potencia_modulo || 0)
    const quantidadeModulo = Number(kit?.quantidade_modulo || cliente?.quantidade_modulo || 0)
    if (potenciaModulo > 0 && quantidadeModulo > 0) {
      return ((potenciaModulo * quantidadeModulo) / 1000).toFixed(2).replace('.', ',')
    }
    return '0,00'
  }

  const numeroParaExtensoBRL = (valor) => {
    const unidades = ['zero', 'um', 'dois', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove']
    const especiais = ['dez', 'onze', 'doze', 'treze', 'quatorze', 'quinze', 'dezesseis', 'dezessete', 'dezoito', 'dezenove']
    const dezenas = ['', '', 'vinte', 'trinta', 'quarenta', 'cinquenta', 'sessenta', 'setenta', 'oitenta', 'noventa']
    const centenas = ['', 'cento', 'duzentos', 'trezentos', 'quatrocentos', 'quinhentos', 'seiscentos', 'setecentos', 'oitocentos', 'novecentos']

    const extensoAte999 = (n) => {
      if (n === 0) return ''
      if (n === 100) return 'cem'
      const c = Math.floor(n / 100)
      const d = Math.floor((n % 100) / 10)
      const u = n % 10
      const partes = []
      if (c > 0) partes.push(centenas[c])
      if (d === 1) {
        partes.push(especiais[u])
      } else {
        if (d > 1) partes.push(dezenas[d])
        if (u > 0) partes.push(unidades[u])
      }
      return partes.join(' e ')
    }

    const inteiro = Math.floor(valor)
    const centavos = Math.round((valor - inteiro) * 100)
    const milhoes = Math.floor(inteiro / 1000000)
    const milhares = Math.floor((inteiro % 1000000) / 1000)
    const resto = inteiro % 1000
    const partesReais = []

    if (milhoes > 0) partesReais.push(`${extensoAte999(milhoes)} ${milhoes === 1 ? 'milhão' : 'milhões'}`)
    if (milhares > 0) partesReais.push(`${extensoAte999(milhares)} mil`)
    if (resto > 0) partesReais.push(extensoAte999(resto))

    let textoReais = partesReais.length ? partesReais.join(' e ') : 'zero'
    textoReais += inteiro === 1 ? ' real' : ' reais'

    if (centavos > 0) {
      const textoCentavos = `${extensoAte999(centavos)} ${centavos === 1 ? 'centavo' : 'centavos'}`
      return `${textoReais} e ${textoCentavos}`
    }
    return textoReais
  }

  const capitalizeFirst = (text) => {
    const t = String(text || '')
    return t ? t.charAt(0).toUpperCase() + t.slice(1) : ''
  }

  const buildProcuracaoOutorgadoTexto = (procurador) => {
    if (!procurador) {
      return `OUTORGADO: R DE S BARROS JUNIOR LTDA com sede legal na Travessa WE 29, N° 02, Bairro: Cidade nova IV, CEP: 67133-120, Cidade: Ananindeua/PA, inscrito no CNPJ no 44.376.302.0001-34 e WALLAFE SOUSA BARROS, portador do CPF N° 918.950.222-15 CFT, residente e domiciliado(a) na Rua Zumbi dos palmares número 131 Ananindeua-PA CEP: 67032031`
    }
    const cpfProc = procurador.cpf
      ? String(procurador.cpf).replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
      : 'N/A'
    const partesEndereco = []
    if (procurador.endereco) partesEndereco.push(procurador.endereco)
    if (procurador.numero) partesEndereco.push(`N° ${procurador.numero}`)
    if (procurador.bairro) partesEndereco.push(`Bairro: ${procurador.bairro}`)
    if (procurador.cep) partesEndereco.push(`CEP: ${procurador.cep}`)
    if (procurador.cidade) partesEndereco.push(`Cidade: ${procurador.cidade}`)
    const endereco = partesEndereco.length > 0 ? partesEndereco.join(', ') : 'endereço não informado'
    return `OUTORGADO: ${procurador.nome_procurador}, portador(a) do CPF N° ${cpfProc}, residente e domiciliado(a) na ${endereco}.`
  }

  const buildProcuracaoPdf = (cliente, procurador = null) => {
    const pdf = new jsPDF('p', 'mm', 'a4')
    const pageWidth = pdf.internal.pageSize.getWidth()
    const margin = 20
    let currentY = 30
    const primaryColor = [33, 37, 41]
    const textColor = [51, 51, 51]
    pdf.setFontSize(18)
    pdf.setFont('helvetica', 'bold')
    pdf.setTextColor(...primaryColor)
    pdf.text('PROCURAÇÃO', pageWidth / 2, currentY, { align: 'center' })
    currentY += 20
    currentY += 10
    pdf.setFontSize(12)
    pdf.setFont('helvetica', 'normal')
    pdf.setTextColor(...textColor)
    const nomeCliente = cliente.nome_completo || 'Nome não informado'
    const cpfCliente = cliente.cpf ? String(cliente.cpf).replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : 'N/A'
    const rgCliente = cliente.rg || 'N/A'
    const enderecoCliente = formatarEndereco(cliente)
    const textoOutorgante = `OUTORGANTE: ${nomeCliente} portador(a) do CPF N° ${cpfCliente} RG N° ${rgCliente}, residente e domiciliado na ${enderecoCliente}`
    const linesOutorgante = pdf.splitTextToSize(textoOutorgante, pageWidth - (margin * 2))
    pdf.text(linesOutorgante, margin, currentY)
    currentY += linesOutorgante.length * 7
    currentY += 10
    const textoOutorgado = buildProcuracaoOutorgadoTexto(procurador)
    const linesOutorgado = pdf.splitTextToSize(textoOutorgado, pageWidth - (margin * 2))
    pdf.text(linesOutorgado, margin, currentY)
    currentY += linesOutorgado.length * 7
    currentY += 10
    pdf.setFont('helvetica', 'bold')
    pdf.text('PODERES:', margin, currentY)
    currentY += 7
    pdf.setFont('helvetica', 'normal')
    const textoPoderes = `Representar o Outorgante perante a Equatorial Energia, podendo para tanto requerer e assinar tudo que for necessário, apresentar, juntar e retirar documentos e multas, fazer declarações, assinar projeto elétrico, assinar contrato de fornecimento, fazer troca de titularidade, solicitar ligação nova, solicitar religação e ou qualquer serviço ligado a área comercial da Concessionária. A procuração tem validade de 1 (um) ano a contar da expedição da mesma.`
    const linesPoderes = pdf.splitTextToSize(textoPoderes, pageWidth - (margin * 2))
    pdf.text(linesPoderes, margin, currentY)
    currentY += linesPoderes.length * 7
    currentY += 20
    const dataAtual = new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
    pdf.text(`Ananindeua/PA, ${dataAtual}`, margin, currentY)
    currentY += 20
    pdf.setDrawColor(200, 200, 200)
    pdf.setLineWidth(0.5)
    pdf.line(margin, currentY, pageWidth - margin, currentY)
    currentY += 5
    pdf.setFontSize(10)
    pdf.text('Assinatura do Outorgante', margin, currentY)
    return { pdf, nomeArquivo: `Procuração_${nomeCliente.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf` }
  }

  const gerarProcuracaoPDF = (cliente, procurador = null) => {
    try {
      const { pdf, nomeArquivo } = buildProcuracaoPdf(cliente, procurador)
      pdf.save(nomeArquivo)
      showNotification('Procuração gerada com sucesso!', 'success')
    } catch (error) {
      console.error('Erro ao gerar PDF da procuração:', error)
      showNotification('Erro ao gerar procuração: ' + error.message, 'error')
    }
  }

  const escapeHtmlProc = (s) => String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')

  const fetchProcuradoresAtivos = async () => {
    const { data, error } = await supabase
      .from('procuradores')
      .select('*')
      .eq('ativo', true)
      .order('nome_procurador', { ascending: true })
    if (error) throw error
    return data || []
  }

  const cadastrarProcuradorSwal = async () => {
    const { value: formValues } = await Swal.fire({
      title: 'Novo procurador',
      width: 520,
      html: `
        <div style="text-align:left;">
          <label style="display:block;font-size:0.85rem;font-weight:600;margin:0 0 2px;">Nome completo *</label>
          <input id="proc-nome" class="swal2-input" placeholder="Nome do procurador" style="margin:0 0 8px;width:100%;box-sizing:border-box;">
          <label style="display:block;font-size:0.85rem;font-weight:600;margin:0 0 2px;">CPF</label>
          <input id="proc-cpf" class="swal2-input" placeholder="Somente números (11 dígitos)" maxlength="11" style="margin:0 0 8px;width:100%;box-sizing:border-box;">
          <label style="display:block;font-size:0.85rem;font-weight:600;margin:0 0 2px;">CEP</label>
          <div style="display:flex;gap:6px;margin:0 0 8px;">
            <input id="proc-cep" class="swal2-input" placeholder="00000-000" maxlength="9" style="margin:0;flex:1;box-sizing:border-box;">
            <button type="button" id="proc-buscar-cep" class="swal2-styled" style="margin:0;background:#0d6efd;white-space:nowrap;">🔍 Buscar</button>
          </div>
          <label style="display:block;font-size:0.85rem;font-weight:600;margin:0 0 2px;">Endereço</label>
          <input id="proc-endereco" class="swal2-input" placeholder="Logradouro" style="margin:0 0 8px;width:100%;box-sizing:border-box;">
          <div style="display:flex;gap:6px;">
            <div style="flex:0 0 35%;">
              <label style="display:block;font-size:0.85rem;font-weight:600;margin:0 0 2px;">Número</label>
              <input id="proc-numero" class="swal2-input" placeholder="N°" style="margin:0 0 8px;width:100%;box-sizing:border-box;">
            </div>
            <div style="flex:1;">
              <label style="display:block;font-size:0.85rem;font-weight:600;margin:0 0 2px;">Bairro</label>
              <input id="proc-bairro" class="swal2-input" placeholder="Bairro" style="margin:0 0 8px;width:100%;box-sizing:border-box;">
            </div>
          </div>
          <label style="display:block;font-size:0.85rem;font-weight:600;margin:0 0 2px;">Cidade</label>
          <input id="proc-cidade" class="swal2-input" placeholder="Cidade/UF" style="margin:0;width:100%;box-sizing:border-box;">
        </div>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Salvar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#0d6efd',
      didOpen: () => {
        const btn = document.getElementById('proc-buscar-cep')
        if (btn) {
          btn.addEventListener('click', async () => {
            const cep = (document.getElementById('proc-cep').value || '').replace(/\D/g, '')
            if (cep.length !== 8) {
              Swal.showValidationMessage('CEP inválido. Digite 8 dígitos.')
              return
            }
            Swal.resetValidationMessage()
            btn.textContent = '🔄'
            try {
              const resp = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
              const data = await resp.json()
              if (data.erro) {
                Swal.showValidationMessage('CEP não encontrado.')
                return
              }
              if (data.logradouro) document.getElementById('proc-endereco').value = data.logradouro
              if (data.bairro) document.getElementById('proc-bairro').value = data.bairro
              const cidadeUf = data.localidade && data.uf ? `${data.localidade}/${data.uf}` : (data.localidade || '')
              if (cidadeUf) document.getElementById('proc-cidade').value = cidadeUf
            } catch (e) {
              Swal.showValidationMessage('Erro ao buscar CEP.')
            } finally {
              btn.textContent = '🔍 Buscar'
            }
          })
        }
      },
      preConfirm: () => {
        const nome = (document.getElementById('proc-nome').value || '').trim()
        if (!nome) {
          Swal.showValidationMessage('Informe o nome do procurador.')
          return false
        }
        return {
          nome_procurador: nome,
          cpf: (document.getElementById('proc-cpf').value || '').replace(/\D/g, '') || null,
          cep: (document.getElementById('proc-cep').value || '').trim() || null,
          endereco: (document.getElementById('proc-endereco').value || '').trim() || null,
          numero: (document.getElementById('proc-numero').value || '').trim() || null,
          bairro: (document.getElementById('proc-bairro').value || '').trim() || null,
          cidade: (document.getElementById('proc-cidade').value || '').trim() || null
        }
      }
    })

    if (!formValues) return null

    try {
      const { data, error } = await supabase
        .from('procuradores')
        .insert({ ...formValues, ativo: true })
        .select()
        .single()
      if (error) throw error
      await loadProcuradores()
      await Swal.fire({ icon: 'success', title: 'Procurador cadastrado!', timer: 1200, showConfirmButton: false })
      return data
    } catch (err) {
      console.error('Erro ao cadastrar procurador:', err)
      await Swal.fire({ icon: 'error', title: 'Erro', text: 'Não foi possível cadastrar: ' + (err.message || 'erro desconhecido') })
      return null
    }
  }

  const abrirModalProcurador = async (cliente) => {
    if (!cliente) return
    let lista = []
    try {
      lista = await fetchProcuradoresAtivos()
    } catch (err) {
      console.error('Erro ao carregar procuradores:', err)
      lista = procuradores
    }

    // eslint-disable-next-line no-constant-condition
    while (true) {
      const optionsHtml = lista.length > 0
        ? `<select id="proc-select" class="swal2-select" style="width:100%;margin:0;">${lista.map(p => `<option value="${p.id}">${escapeHtmlProc(p.nome_procurador)}${p.cpf ? ` – ${formatCPFDisplay(p.cpf)}` : ''}</option>`).join('')}</select>`
        : `<p style="color:#6c757d;margin:0;">Nenhum procurador cadastrado. Clique em "Cadastrar novo" para adicionar.</p>`

      const result = await Swal.fire({
        title: '📋 Gerar Procuração',
        width: 520,
        html: `
          <p style="margin:0 0 12px;text-align:left;"><strong>Cliente:</strong> ${escapeHtmlProc(cliente.nome_completo || '–')}</p>
          <label style="display:block;text-align:left;font-size:0.9rem;font-weight:600;margin:0 0 4px;">Selecione o procurador (outorgado)</label>
          ${optionsHtml}
        `,
        focusConfirm: false,
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: 'Gerar Procuração',
        denyButtonText: '➕ Cadastrar novo',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#0d6efd',
        denyButtonColor: '#198754',
        preConfirm: () => {
          const sel = document.getElementById('proc-select')
          if (!sel || !sel.value) {
            Swal.showValidationMessage('Selecione um procurador ou cadastre um novo.')
            return false
          }
          return sel.value
        }
      })

      if (result.isConfirmed) {
        const procurador = lista.find(p => String(p.id) === String(result.value))
        if (procurador) {
          gerarProcuracaoPDF(cliente, procurador)
        } else {
          showNotification('Procurador selecionado não encontrado.', 'error')
        }
        return
      }

      if (result.isDenied) {
        await cadastrarProcuradorSwal()
        try {
          lista = await fetchProcuradoresAtivos()
        } catch (err) {
          console.error('Erro ao recarregar procuradores:', err)
        }
        continue
      }

      // Cancelado ou fechado
      return
    }
  }

  const fecharDocumentoLxpModal = () => {
    if (gerandoContratoLxp) return
    setShowDocumentoLxpModal(false)
    if (!showValorContratoLxpModal) setClienteDocumentoLxp(null)
    setValorContratoLxpInput('')
  }

  const fecharValorContratoLxpModal = () => {
    if (gerandoContratoLxp) return
    setShowValorContratoLxpModal(false)
    setValorContratoLxpInput('')
    setClienteDocumentoLxp(null)
  }

  const abrirFluxoGerarDocumento = (cliente) => {
    if (userEmpresa?.id === EMPRESA_ID_LXP) {
      setClienteDocumentoLxp(cliente)
      setValorContratoLxpInput('')
      setShowValorContratoLxpModal(false)
      setShowDocumentoLxpModal(true)
      return
    }
    abrirModalProcurador(cliente)
  }

  const gerarContratoLxpDocxBuffer = async (cliente, valorInformado) => {
    const valorNumero = parseCurrencyInput(valorInformado)
    if (!valorNumero || valorNumero <= 0) {
      showNotification('Informe um valor válido para gerar o contrato.', 'error')
      return null
    }

    const templateUrl = `${process.env.PUBLIC_URL || ''}/docs/ModeloContratoLXP.docx`
    const response = await fetch(templateUrl)
    if (!response.ok) throw new Error('ModeloContratoLXP.docx não encontrado')

    const arrayBuffer = await response.arrayBuffer()
    const JSZip = (await import('jszip')).default
    const zip = await JSZip.loadAsync(arrayBuffer)

    const escapeXml = (s) => String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;')

    const valorFormatado = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valorNumero)
    const substituicoes = {
      '{CLIENTE}': (cliente?.nome_completo || '').trim() || 'Não informado',
      '{CPFCLIENTE}': formatCPFDisplay(cliente?.cpf || ''),
      '{RG}': cliente?.rg || 'Não informado',
      '{ENDERECO}': formatarEndereco(cliente),
      '{POTENCIA}': `${getPotenciaKwpCliente(cliente)} kWp`,
      '{VALOR}': valorFormatado,
      '{VALOREXTENSO}': capitalizeFirst(numeroParaExtensoBRL(valorNumero)),
      '{DATA}': formatarDataExtenso(new Date())
    }

    const promises = []
    zip.forEach((relativePath, file) => {
      if (!file.dir && (relativePath.endsWith('.xml') || relativePath.endsWith('.rels'))) {
        promises.push(
          file.async('string').then((text) => {
            let novoTexto = text
            Object.entries(substituicoes).forEach(([placeholder, valor]) => {
              const valorSafe = escapeXml(valor)
              novoTexto = novoTexto.split(placeholder).join(valorSafe)
              const key = placeholder.slice(1, -1)
              const regex = new RegExp(
                '\\{(?:<[^>]+>|\\s)*' +
                key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') +
                '(?:<[^>]+>|\\s)*\\}',
                'g'
              )
              novoTexto = novoTexto.replace(regex, valorSafe)
            })
            zip.file(relativePath, novoTexto)
          })
        )
      }
    })
    await Promise.all(promises)

    const filledDocxArrayBuffer = await zip.generateAsync({ type: 'arraybuffer' })
    return { filledDocxArrayBuffer }
  }

  const finalizarFluxoContratoLxpSucesso = () => {
    setShowValorContratoLxpModal(false)
    setShowDocumentoLxpModal(false)
    setClienteDocumentoLxp(null)
    setValorContratoLxpInput('')
  }

  const gerarContratoLxpDocx = async (cliente, valorInformado) => {
    setGerandoContratoLxp(true)
    try {
      const result = await gerarContratoLxpDocxBuffer(cliente, valorInformado)
      if (!result) return
      const { filledDocxArrayBuffer } = result
      const blob = new Blob([filledDocxArrayBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      })
      const nomeCliente = (cliente?.nome_completo || 'Cliente').trim().replace(/\s+/g, '_')
      saveAs(blob, `Contrato_${nomeCliente}_${new Date().toISOString().split('T')[0]}.docx`)
      showNotification('Contrato gerado com sucesso!', 'success')
      finalizarFluxoContratoLxpSucesso()
    } catch (error) {
      console.error('Erro ao gerar contrato LXP:', error)
      showNotification('Erro ao gerar contrato: ' + error.message, 'error')
    } finally {
      setGerandoContratoLxp(false)
    }
  }

  // ===== Contrato em PDF (mesmo modelo de Gestão de Clientes, com logo da empresa) =====

  // Busca a empresa CONTRATADA (dados + logo) na tabela empresa.
  const getEmpresaContratada = async (empresaId) => {
    if (!empresaId) return null
    try {
      const { data, error } = await supabase
        .from('empresa')
        .select('*')
        .eq('id', empresaId)
        .single()
      if (error) {
        console.warn('Contrato: não foi possível carregar a empresa contratada.', error.message)
        return null
      }
      return data
    } catch (e) {
      console.warn('Contrato: erro ao carregar empresa contratada.', e && e.message)
      return null
    }
  }

  // Converte a logo (URL) em data URI para evitar problemas de CORS no html2canvas.
  const fetchImageAsDataUrl = async (url) => {
    if (!url) return null
    try {
      const res = await fetch(url, { mode: 'cors' })
      if (!res.ok) return null
      const blob = await res.blob()
      return await new Promise((resolve) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = () => resolve(null)
        reader.readAsDataURL(blob)
      })
    } catch (e) {
      console.warn('Contrato: não foi possível carregar a logo da empresa.', e && e.message)
      return null
    }
  }

  // Resolve os campos da CONTRATADA, com fallback para os dados da HangSix.
  const resolverEmpresaContrato = (empresa) => {
    const enderecoBruto = (empresa && empresa.endereco) ? String(empresa.endereco).trim() : ''
    const enderecoLower = enderecoBruto.toLowerCase()
    const enderecoValido = enderecoBruto && !enderecoLower.startsWith('http') && !enderecoLower.includes('www.')
    return {
      empresaNome: (empresa && (empresa.empresa || empresa.razao_social)) || 'HangSix Energia Solar',
      empresaRazaoSocial: (empresa && (empresa.razao_social || empresa.empresa)) || 'HangSix Energia Solar',
      empresaCnpj: (empresa && empresa.cnpj) || '44.376.302/0001-34',
      empresaEndereco: enderecoValido ? enderecoBruto : 'Tv. WE29, Nº 2, Cidade Nova IV, CEP: 67133-120, Ananindeua - PA',
      empresaEmail: (empresa && empresa.email) || 'hangsixsolar@gmail.com',
      empresaTelefone: (empresa && (empresa.contato || empresa.telefone || empresa.celular)) || '(91) 9 9253-3339',
      empresaLogo: (empresa && (empresa.logo || empresa.logo_url)) || undefined,
      corPrimaria: (empresa && empresa.cor_primaria_contrato) || undefined,
      corDestaque: (empresa && empresa.cor_destaque_contrato) || undefined
    }
  }

  // Normaliza os dados do contrato: cliente completo (kit + valor) e empresa contratada.
  const getDadosContratoHtml = async (cliente) => {
    let dadosCliente = { ...cliente }
    if (cliente && cliente.id) {
      const { data: clienteCompleto, error } = await supabase
        .from('clientes_cadastro')
        .select(`
          *,
          kit_solar_cliente (
            marca_inversor,
            potencia_inversor,
            quantidade_inversor,
            marca_modulo,
            potencia_modulo,
            quantidade_modulo
          )
        `)
        .eq('id', cliente.id)
        .single()
      if (!error && clienteCompleto) {
        dadosCliente = { ...clienteCompleto }
        const kitRel = dadosCliente.kit_solar_cliente
        const kitUnico = Array.isArray(kitRel) ? kitRel[0] : kitRel
        if (kitUnico && typeof kitUnico === 'object') {
          dadosCliente.marca_inversor = kitUnico.marca_inversor
          dadosCliente.potencia_inversor = kitUnico.potencia_inversor
          dadosCliente.quantidade_inversor = kitUnico.quantidade_inversor
          dadosCliente.marca_modulo = kitUnico.marca_modulo
          dadosCliente.potencia_modulo = kitUnico.potencia_modulo
          dadosCliente.quantidade_modulo = kitUnico.quantidade_modulo
        }
      } else if (error) {
        console.warn('Contrato: busca completa do cliente falhou, usando dados da lista.', error.message)
      }
    }

    const empresa = await getEmpresaContratada(dadosCliente.empresa_id || (cliente && cliente.empresa_id))

    const nomeCliente = dadosCliente.nome_completo || 'Nome não informado'
    const cpfDigits = String(dadosCliente.cpf || '').replace(/[^0-9]/g, '')
    const cpfCliente = cpfDigits.length === 11
      ? `${cpfDigits.slice(0, 3)}.${cpfDigits.slice(3, 6)}.${cpfDigits.slice(6, 9)}-${cpfDigits.slice(9)}`
      : (dadosCliente.cpf || 'N/A')

    const kitRel = dadosCliente.kit_solar_cliente
    const kit = (Array.isArray(kitRel) ? kitRel[0] : kitRel) || {}
    const hasKit = (kit && (kit.marca_inversor || kit.potencia_inversor || kit.quantidade_inversor || kit.marca_modulo || kit.potencia_modulo || kit.quantidade_modulo)) || dadosCliente.marca_inversor || dadosCliente.potencia_inversor || dadosCliente.marca_modulo || dadosCliente.potencia_modulo
    let kitSolarHtml
    if (hasKit) {
      const invMarca = kit.marca_inversor || dadosCliente.marca_inversor || '-'
      const invPot = kit.potencia_inversor != null && kit.potencia_inversor !== '' ? `${kit.potencia_inversor} kW` : (dadosCliente.potencia_inversor != null && dadosCliente.potencia_inversor !== '' ? `${dadosCliente.potencia_inversor} kW` : '-')
      const invQtd = kit.quantidade_inversor != null && kit.quantidade_inversor !== '' ? kit.quantidade_inversor : (dadosCliente.quantidade_inversor != null && dadosCliente.quantidade_inversor !== '' ? dadosCliente.quantidade_inversor : '-')
      const modMarca = kit.marca_modulo || dadosCliente.marca_modulo || '-'
      const modPot = kit.potencia_modulo != null && kit.potencia_modulo !== '' ? `${kit.potencia_modulo} W` : (dadosCliente.potencia_modulo != null && dadosCliente.potencia_modulo !== '' ? `${dadosCliente.potencia_modulo} W` : '-')
      const modQtd = kit.quantidade_modulo != null && kit.quantidade_modulo !== '' ? kit.quantidade_modulo : (dadosCliente.quantidade_modulo != null && dadosCliente.quantidade_modulo !== '' ? dadosCliente.quantidade_modulo : '-')
      kitSolarHtml = `Inversor(es): Marca ${invMarca}, potência ${invPot}, quantidade ${invQtd}.<br>Módulo(s) fotovoltaico(s): Marca ${modMarca}, potência ${modPot}, quantidade ${modQtd}.`
    } else {
      kitSolarHtml = 'Kit solar não cadastrado para este cliente no momento da emissão deste instrumento.'
    }

    const valorProjetoRaw = dadosCliente.valor_total
    const valorProjeto = valorProjetoRaw != null && valorProjetoRaw !== ''
      ? (typeof valorProjetoRaw === 'number' ? valorProjetoRaw : parseFloat(String(valorProjetoRaw).split('.').join('').replace(',', '.')) || 0)
      : 0
    const valorProjetoFormatado = valorProjeto > 0
      ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valorProjeto)
      : 'Não informado'
    const valorTexto = valorProjetoFormatado === 'Não informado'
      ? 'O valor total do projeto não foi informado no cadastro do sistema.'
      : `O valor total do projeto é de ${valorProjetoFormatado}.`

    const multaValor = valorProjeto > 0 ? valorProjeto * 0.5 : 0
    const multaFormatada = multaValor > 0
      ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(multaValor)
      : null
    const multaTexto = multaFormatada
      ? `50% (cinquenta por cento) do valor total do projeto, correspondente a ${multaFormatada}`
      : '50% (cinquenta por cento) do valor total do projeto'

    return { dadosCliente, empresa, nomeCliente, cpfCliente, kitSolarHtml, valorTexto, multaTexto }
  }

  // Renderiza o HTML do contrato em PDF A4 multipágina (html2canvas + jsPDF).
  const renderHtmlToA4Pdf = async (html) => {
    const wrapper = document.createElement('div')
    wrapper.style.position = 'fixed'
    wrapper.style.left = '-10000px'
    wrapper.style.top = '0'
    wrapper.style.width = '794px'
    wrapper.style.padding = '0'
    wrapper.style.background = '#ffffff'
    wrapper.style.boxSizing = 'border-box'
    wrapper.innerHTML = html
    document.body.appendChild(wrapper)
    try {
      const imgs = Array.from(wrapper.querySelectorAll('img'))
      await Promise.all(imgs.map((img) => (img.complete ? Promise.resolve() : new Promise((res) => { img.onload = res; img.onerror = res }))))

      const root = wrapper.querySelector('.contrato-root') || wrapper
      const blocos = Array.from(root.children).filter((el) => el.tagName !== 'STYLE')

      const pdf = new jsPDF('p', 'mm', 'a4')
      const pageW = pdf.internal.pageSize.getWidth()
      const pageH = pdf.internal.pageSize.getHeight()
      const marginX = 12
      const marginY = 14
      const contentW = pageW - marginX * 2
      const usableH = pageH - marginY * 2
      const gap = 3
      let currentY = marginY

      for (const bloco of blocos) {
        const canvas = await html2canvas(bloco, { scale: 2, useCORS: true, backgroundColor: '#ffffff', logging: false })
        if (!canvas.width || !canvas.height) continue
        let imgW = contentW
        let imgH = (canvas.height * imgW) / canvas.width
        if (imgH > usableH) {
          const ratio = usableH / imgH
          imgH = usableH
          imgW = contentW * ratio
        }
        if (currentY + imgH > pageH - marginY && currentY > marginY) {
          pdf.addPage()
          currentY = marginY
        }
        const imgData = canvas.toDataURL('image/jpeg', 0.95)
        pdf.addImage(imgData, 'JPEG', marginX, currentY, imgW, imgH)
        currentY += imgH + gap
      }
      return pdf
    } finally {
      document.body.removeChild(wrapper)
    }
  }

  // Monta o HTML do contrato (fonte única do PDF e do arquivo .html).
  const montarHtmlContratoCliente = async (cliente) => {
    const dados = await getDadosContratoHtml(cliente)
    const empresaResolvida = resolverEmpresaContrato(dados.empresa)
    const temLogo = !!empresaResolvida.empresaLogo
    const logoDataUrl = temLogo ? await fetchImageAsDataUrl(empresaResolvida.empresaLogo) : null

    // As cores personalizadas vêm da própria empresa (colunas cor_primaria_contrato /
    // cor_destaque_contrato). Quando vazias, o template usa as cores padrão.
    const html = buildContratoHtml({
      ...empresaResolvida,
      empresaLogo: logoDataUrl || empresaResolvida.empresaLogo,
      semLogo: !temLogo,
      clienteNome: dados.nomeCliente,
      clienteCpf: dados.cpfCliente,
      kitSolarHtml: dados.kitSolarHtml,
      valorTexto: dados.valorTexto,
      multaTexto: dados.multaTexto
    })
    return { html, nomeCliente: dados.nomeCliente }
  }

  // Gera e baixa o contrato do cliente em PDF (com a logo da empresa contratada).
  const gerarContratoPdfCliente = async (cliente) => {
    setClienteParaContrato(null)
    setGerandoContratoPdfId(cliente?.id || 'novo')
    try {
      const { html, nomeCliente } = await montarHtmlContratoCliente(cliente)
      const pdf = await renderHtmlToA4Pdf(html)
      pdf.save(nomeArquivoContrato(nomeCliente, 'pdf'))
      showNotification('Contrato gerado com sucesso!', 'success')
    } catch (error) {
      console.error('Erro ao gerar PDF do contrato:', error)
      showNotification('Erro ao gerar contrato: ' + error.message, 'error')
    } finally {
      setGerandoContratoPdfId(null)
    }
  }

  // Gera e baixa o mesmo contrato em HTML editável (navegador ou Word).
  const gerarContratoHtmlCliente = async (cliente) => {
    setClienteParaContrato(null)
    setGerandoContratoPdfId(cliente?.id || 'novo')
    try {
      const { html, nomeCliente } = await montarHtmlContratoCliente(cliente)
      const documento = wrapContratoHtmlDocumento(html, `Contrato - ${nomeCliente || 'Cliente'}`)
      const blob = new Blob([documento], { type: 'text/html;charset=utf-8' })
      saveAs(blob, nomeArquivoContrato(nomeCliente, 'html'))
      showNotification('Contrato em HTML gerado com sucesso!', 'success')
    } catch (error) {
      console.error('Erro ao gerar HTML do contrato:', error)
      showNotification('Erro ao gerar contrato: ' + error.message, 'error')
    } finally {
      setGerandoContratoPdfId(null)
    }
  }

  const buildContratoPdf = async (cliente, valorProjetoInformado = null) => {
    let dadosCliente = { ...cliente }
    if (cliente?.id) {
      const { data: clienteCompleto, error } = await supabase
        .from('clientes_cadastro')
        .select(`
          *,
          kit_solar_cliente (
            marca_inversor,
            potencia_inversor,
            quantidade_inversor,
            marca_modulo,
            potencia_modulo,
            quantidade_modulo
          )
        `)
        .eq('id', cliente.id)
        .single()
      if (!error && clienteCompleto) {
        dadosCliente = { ...clienteCompleto }
        const kitRel = dadosCliente.kit_solar_cliente
        const kitUnico = Array.isArray(kitRel) ? kitRel[0] : kitRel
        if (kitUnico && typeof kitUnico === 'object') {
          dadosCliente.marca_inversor = kitUnico.marca_inversor
          dadosCliente.potencia_inversor = kitUnico.potencia_inversor
          dadosCliente.quantidade_inversor = kitUnico.quantidade_inversor
          dadosCliente.marca_modulo = kitUnico.marca_modulo
          dadosCliente.potencia_modulo = kitUnico.potencia_modulo
          dadosCliente.quantidade_modulo = kitUnico.quantidade_modulo
        }
      } else {
        if (cliente.kit_solar_cliente) {
          const k = Array.isArray(cliente.kit_solar_cliente) ? cliente.kit_solar_cliente[0] : cliente.kit_solar_cliente
          if (k && typeof k === 'object') {
            dadosCliente.marca_inversor = dadosCliente.marca_inversor ?? k.marca_inversor
            dadosCliente.potencia_inversor = dadosCliente.potencia_inversor ?? k.potencia_inversor
            dadosCliente.quantidade_inversor = dadosCliente.quantidade_inversor ?? k.quantidade_inversor
            dadosCliente.marca_modulo = dadosCliente.marca_modulo ?? k.marca_modulo
            dadosCliente.potencia_modulo = dadosCliente.potencia_modulo ?? k.potencia_modulo
            dadosCliente.quantidade_modulo = dadosCliente.quantidade_modulo ?? k.quantidade_modulo
          }
        }
        dadosCliente.valor_total = dadosCliente.valor_total ?? cliente.valor_total
      }
    }
    const pdf = new jsPDF('p', 'mm', 'a4')
    const pageWidth = pdf.internal.pageSize.getWidth()
    const pageHeight = pdf.internal.pageSize.getHeight()
    const margin = 20
    const marginTop = 38
    let currentY = marginTop
    const primaryColor = [33, 37, 41]
    const textColor = [51, 51, 51]
    const sectionColor = [66, 66, 66]
    const checkPageBreak = (requiredSpace = 10) => {
      if (currentY + requiredSpace > pageHeight - margin) {
        pdf.addPage()
        currentY = marginTop
        return true
      }
      return false
    }
    const nomeCliente = dadosCliente.nome_completo || 'Nome não informado'
    const cpfCliente = dadosCliente.cpf ? dadosCliente.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : 'N/A'
    pdf.setFontSize(14)
    pdf.setFont('helvetica', 'bold')
    pdf.setTextColor(...primaryColor)
    pdf.text('CONTRATO DE PROJETO E INSTALAÇÃO FOTOVOLTAICO', pageWidth / 2, currentY, { align: 'center' })
    currentY += 10
    pdf.setFontSize(10)
    pdf.setFont('helvetica', 'normal')
    pdf.text('Instrumento particular de prestação de serviços', pageWidth / 2, currentY, { align: 'center' })
    currentY += 14
    checkPageBreak(20)
    pdf.setFontSize(12)
    pdf.setFont('helvetica', 'bold')
    pdf.setTextColor(...sectionColor)
    pdf.text('1. PARTES CONTRATANTES', margin, currentY)
    currentY += 8
    pdf.setFontSize(10)
    pdf.setFont('helvetica', 'normal')
    pdf.setTextColor(...textColor)
    const textoContratada = 'CONTRATADA: HangSix Energia Solar, inscrita no CNPJ sob nº 44.376.302/0001-34, com sede na Tv. WE29, Nº 2, Cidade Nova IV, 67133-120, doravante denominada CONTRATADA.'
    const linesContratada = pdf.splitTextToSize(textoContratada, pageWidth - (margin * 2))
    pdf.text(linesContratada, margin, currentY)
    currentY += linesContratada.length * 6 + 5
    const textoContratante = `CONTRATANTE: ${nomeCliente}, inscrito no CPF/CNPJ sob nº ${cpfCliente}, doravante denominado CONTRATANTE.`
    const linesContratante = pdf.splitTextToSize(textoContratante, pageWidth - (margin * 2))
    pdf.text(linesContratante, margin, currentY)
    currentY += linesContratante.length * 6 + 10
    checkPageBreak(20)
    pdf.setFontSize(12)
    pdf.setFont('helvetica', 'bold')
    pdf.setTextColor(...sectionColor)
    pdf.text('2. OBJETO DO CONTRATO', margin, currentY)
    currentY += 8
    pdf.setFontSize(10)
    pdf.setFont('helvetica', 'normal')
    pdf.setTextColor(...textColor)
    const textoObjeto = 'Prestação de serviços de instalação do sistema fotovoltaico, incluindo homologação junto à concessionária, monitoramento por 1 (um) ano, e fornecimento de garantia dos equipamentos (placas e inversor) conforme políticas dos fabricantes.'
    const linesObjeto = pdf.splitTextToSize(textoObjeto, pageWidth - (margin * 2))
    pdf.text(linesObjeto, margin, currentY)
    currentY += linesObjeto.length * 6 + 10
    const kitRel = dadosCliente.kit_solar_cliente
    const kit = (Array.isArray(kitRel) ? kitRel[0] : kitRel) || {}
    const hasKit = (kit && (kit.marca_inversor || kit.potencia_inversor || kit.quantidade_inversor || kit.marca_modulo || kit.potencia_modulo || kit.quantidade_modulo)) || dadosCliente.marca_inversor || dadosCliente.potencia_inversor || dadosCliente.marca_modulo || dadosCliente.potencia_modulo
    checkPageBreak(25)
    pdf.setFontSize(11)
    pdf.setFont('helvetica', 'bold')
    pdf.setTextColor(...sectionColor)
    pdf.text('2.1. ESPECIFICAÇÃO DO KIT SOLAR', margin, currentY)
    currentY += 8
    pdf.setFontSize(10)
    pdf.setFont('helvetica', 'normal')
    pdf.setTextColor(...textColor)
    if (hasKit) {
      const invMarca = kit.marca_inversor || dadosCliente.marca_inversor || '–'
      const invPot = kit.potencia_inversor != null && kit.potencia_inversor !== '' ? `${kit.potencia_inversor} kW` : (dadosCliente.potencia_inversor != null && dadosCliente.potencia_inversor !== '' ? `${dadosCliente.potencia_inversor} kW` : '–')
      const invQtd = kit.quantidade_inversor != null && kit.quantidade_inversor !== '' ? kit.quantidade_inversor : (dadosCliente.quantidade_inversor != null && dadosCliente.quantidade_inversor !== '' ? dadosCliente.quantidade_inversor : '–')
      const modMarca = kit.marca_modulo || dadosCliente.marca_modulo || '–'
      const modPot = kit.potencia_modulo != null && kit.potencia_modulo !== '' ? `${kit.potencia_modulo} W` : (dadosCliente.potencia_modulo != null && dadosCliente.potencia_modulo !== '' ? `${dadosCliente.potencia_modulo} W` : '–')
      const modQtd = kit.quantidade_modulo != null && kit.quantidade_modulo !== '' ? kit.quantidade_modulo : (dadosCliente.quantidade_modulo != null && dadosCliente.quantidade_modulo !== '' ? dadosCliente.quantidade_modulo : '–')
      let textoKit = `Inversor(es): Marca ${invMarca}, potência ${invPot}, quantidade ${invQtd}.`
      const linesInv = pdf.splitTextToSize(textoKit, pageWidth - (margin * 2))
      pdf.text(linesInv, margin, currentY)
      currentY += linesInv.length * 6 + 3
      textoKit = `Módulo(s) fotovoltaico(s): Marca ${modMarca}, potência ${modPot}, quantidade ${modQtd}.`
      const linesMod = pdf.splitTextToSize(textoKit, pageWidth - (margin * 2))
      pdf.text(linesMod, margin, currentY)
      currentY += linesMod.length * 6 + 8
    } else {
      const linesKitVazio = pdf.splitTextToSize('Kit solar não cadastrado para este cliente.', pageWidth - (margin * 2))
      pdf.text(linesKitVazio, margin, currentY)
      currentY += linesKitVazio.length * 6 + 8
    }
    const valorProjetoRaw = valorProjetoInformado != null ? valorProjetoInformado : dadosCliente.valor_total
    const valorProjeto = valorProjetoRaw != null && valorProjetoRaw !== '' ? (typeof valorProjetoRaw === 'number' ? valorProjetoRaw : parseFloat(String(valorProjetoRaw).replace(/\./g, '').replace(',', '.')) || 0) : 0
    const valorProjetoFormatado = valorProjeto > 0 ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valorProjeto) : 'Não informado'
    checkPageBreak(15)
    pdf.setFontSize(11)
    pdf.setFont('helvetica', 'bold')
    pdf.setTextColor(...sectionColor)
    pdf.text('2.2. VALOR DO PROJETO', margin, currentY)
    currentY += 8
    pdf.setFontSize(10)
    pdf.setFont('helvetica', 'normal')
    pdf.setTextColor(...textColor)
    const textoValor = typeof valorProjetoFormatado === 'string' && valorProjetoFormatado === 'Não informado' ? 'O valor total do projeto não foi informado no cadastro.' : `O valor total do projeto é de ${valorProjetoFormatado}.`
    const linesValor = pdf.splitTextToSize(textoValor, pageWidth - (margin * 2))
    pdf.text(linesValor, margin, currentY)
    currentY += linesValor.length * 6 + 8
    checkPageBreak(20)
    pdf.setFontSize(12)
    pdf.setFont('helvetica', 'bold')
    pdf.setTextColor(...sectionColor)
    pdf.text('3. OBRIGAÇÕES DA CONTRATADA', margin, currentY)
    currentY += 8
    pdf.setFontSize(10)
    pdf.setFont('helvetica', 'normal')
    pdf.setTextColor(...textColor)
    const obrigacoes = [
      '1. Fornecimento e instalação de materiais elétricos estritamente necessários à execução do serviço e instalação do projeto (quadro de string DC, quadro de paralelo AC);',
      '2. Fornecimento e instalação de estrutura metálica para suporte de módulos fotovoltaicos;',
      '3. Conexão elétrica entre módulos, quadros DC, inversor e quadro de baixa tensão;',
      '4. Teste de funcionalidade e entrega de conformidade da usina;',
      '5. Avaliação do projeto de ajuste, caso seja necessário;',
      '6. Tratamento do processo de homologação do sistema junto à Concessionária de Energia Elétrica (Equatorial) e solicitação de aumento de carga (monofásico para bifásico).'
    ]
    obrigacoes.forEach(obrigacao => {
      checkPageBreak(15)
      const lines = pdf.splitTextToSize(obrigacao, pageWidth - (margin * 2))
      pdf.text(lines, margin, currentY)
      currentY += lines.length * 6 + 3
    })
    currentY += 5
    checkPageBreak(20)
    pdf.setFontSize(12)
    pdf.setFont('helvetica', 'bold')
    pdf.setTextColor(...sectionColor)
    pdf.text('4. ITENS EXCLUÍDOS DO CONTRATO', margin, currentY)
    currentY += 8
    pdf.setFontSize(10)
    pdf.setFont('helvetica', 'normal')
    pdf.setTextColor(...textColor)
    const itensExcluidos = [
      '1. Obras civis: estrutura de edifícios, fundações, terraplenagem, armação, drenagem, ampliação, inovação ou restauração no imóvel;',
      '2. Fornecimento de telha, exceto quando no momento da instalação alguma telha for danificada;',
      '3. Obras de transmissão de energia em linha aérea: cabeamento que liga a residência até a rede da concessionária, procedimentos esses de responsabilidade da concessionária de energia;',
      '4. Estrutura mecânica de reforço do telhado (onde previsto no laudo de vistoria);',
      '5. Implantação e custeio de poste auxiliar, quando necessário e indicado na vistoria;',
      '6. Cálculo estrutural do telhado (quando não previsto no item 2.1).'
    ]
    itensExcluidos.forEach(item => {
      checkPageBreak(15)
      const lines = pdf.splitTextToSize(item, pageWidth - (margin * 2))
      pdf.text(lines, margin, currentY)
      currentY += lines.length * 6 + 3
    })
    currentY += 5
    checkPageBreak(20)
    pdf.setFontSize(12)
    pdf.setFont('helvetica', 'bold')
    pdf.setTextColor(...sectionColor)
    pdf.text('5. RESPONSABILIDADES DA CONTRATANTE', margin, currentY)
    currentY += 8
    pdf.setFontSize(10)
    pdf.setFont('helvetica', 'normal')
    pdf.setTextColor(...textColor)
    const responsabilidades = [
      '- Manter o ponto de conexão de internet ligado ao sistema fotovoltaico sempre ativo, devendo realizar os procedimentos e medidas indicadas pela CONTRATADA para restabelecer o funcionamento em caso de falha;',
      '- Armazenar o material entregue em local seguro, sendo de sua responsabilidade prevenir roubo, furto e danos aos materiais após e durante a instalação;',
      '- Responsabilizar-se por quaisquer ocorrências de roubo e furto após a entrega dos materiais e durante o serviço.'
    ]
    responsabilidades.forEach(resp => {
      checkPageBreak(15)
      const lines = pdf.splitTextToSize(resp, pageWidth - (margin * 2))
      pdf.text(lines, margin, currentY)
      currentY += lines.length * 6 + 3
    })
    currentY += 5
    checkPageBreak(20)
    pdf.setFontSize(12)
    pdf.setFont('helvetica', 'bold')
    pdf.setTextColor(...sectionColor)
    pdf.text('6. GARANTIA E MANUTENÇÃO', margin, currentY)
    currentY += 8
    pdf.setFontSize(10)
    pdf.setFont('helvetica', 'normal')
    pdf.setTextColor(...textColor)
    const textoGarantia = 'A CONTRATADA garante a execução dos serviços e a integridade da instalação. A garantia dos equipamentos (placas e inversores) é de responsabilidade dos fabricantes. Será oferecida 1 (uma) manutenção gratuita dentro de 1 (um) ano após a instalação.'
    const linesGarantia = pdf.splitTextToSize(textoGarantia, pageWidth - (margin * 2))
    pdf.text(linesGarantia, margin, currentY)
    currentY += linesGarantia.length * 6 + 10
    checkPageBreak(20)
    pdf.setFontSize(12)
    pdf.setFont('helvetica', 'bold')
    pdf.setTextColor(...sectionColor)
    pdf.text('7. DANOS COBERTOS', margin, currentY)
    currentY += 8
    pdf.setFontSize(10)
    pdf.setFont('helvetica', 'normal')
    pdf.setTextColor(...textColor)
    const textoDanos = 'Danos ao equipamento serão cobertos caso sejam decorrentes de transporte inadequado, má instalação ou durante o processo de instalação. Danos posteriores são de responsabilidade do CONTRATANTE.'
    const linesDanos = pdf.splitTextToSize(textoDanos, pageWidth - (margin * 2))
    pdf.text(linesDanos, margin, currentY)
    currentY += linesDanos.length * 6 + 10
    checkPageBreak(25)
    pdf.setFontSize(12)
    pdf.setFont('helvetica', 'bold')
    pdf.setTextColor(...sectionColor)
    pdf.text('8. SUSPENSÃO DE PRAZOS', margin, currentY)
    currentY += 8
    pdf.setFontSize(10)
    pdf.setFont('helvetica', 'normal')
    pdf.setTextColor(...textColor)
    const textoSuspensao = 'Os prazos serão suspensos sempre que ocorrerem atrasos decorrentes de condutas não imputáveis à CONTRATADA, voltando a correr de onde pararam assim que corrigida a circunstância.'
    const linesSuspensao = pdf.splitTextToSize(textoSuspensao, pageWidth - (margin * 2))
    pdf.text(linesSuspensao, margin, currentY)
    currentY += linesSuspensao.length * 6 + 10
    checkPageBreak(20)
    pdf.setFontSize(12)
    pdf.setFont('helvetica', 'bold')
    pdf.setTextColor(...sectionColor)
    pdf.text('9. CONTATO E SUPORTE', margin, currentY)
    currentY += 8
    pdf.setFontSize(10)
    pdf.setFont('helvetica', 'normal')
    pdf.setTextColor(...textColor)
    const textoContato = 'Qualquer dúvida, suporte técnico ou atendimento referente ao sistema poderá ser solicitado através do telefone (91) 9 9253-3339 ou e-mail hangsixsolar@gmail.com.'
    const linesContato = pdf.splitTextToSize(textoContato, pageWidth - (margin * 2))
    pdf.text(linesContato, margin, currentY)
    currentY += linesContato.length * 6 + 10
    checkPageBreak(20)
    pdf.setFontSize(12)
    pdf.setFont('helvetica', 'bold')
    pdf.setTextColor(...sectionColor)
    pdf.text('10. DISPOSIÇÕES FINAIS', margin, currentY)
    currentY += 8
    pdf.setFontSize(10)
    pdf.setFont('helvetica', 'normal')
    pdf.setTextColor(...textColor)
    const textoDisposicoes = 'As partes elegem o foro da Comarca de Ananindeua – PA para dirimir quaisquer dúvidas oriundas deste contrato.'
    const linesDisposicoes = pdf.splitTextToSize(textoDisposicoes, pageWidth - (margin * 2))
    pdf.text(linesDisposicoes, margin, currentY)
    currentY += linesDisposicoes.length * 6 + 20
    checkPageBreak(40)
    pdf.setFontSize(10)
    pdf.setFont('helvetica', 'bold')
    pdf.setTextColor(...textColor)
    pdf.text('CONTRATANTE:', margin, currentY)
    currentY += 8
    pdf.setDrawColor(200, 200, 200)
    pdf.setLineWidth(0.5)
    pdf.line(margin, currentY, pageWidth - margin, currentY)
    currentY += 5
    pdf.setFontSize(9)
    pdf.setFont('helvetica', 'normal')
    pdf.text(nomeCliente, margin, currentY)
    currentY += 5
    pdf.text(`CPF/CNPJ: ${cpfCliente}`, margin, currentY)
    currentY += 15
    pdf.setFontSize(10)
    pdf.setFont('helvetica', 'bold')
    pdf.text('CONTRATADA:', margin, currentY)
    currentY += 8
    pdf.setDrawColor(200, 200, 200)
    pdf.setLineWidth(0.5)
    pdf.line(margin, currentY, pageWidth - margin, currentY)
    currentY += 5
    pdf.setFontSize(9)
    pdf.setFont('helvetica', 'normal')
    pdf.text('HangSix Energia Solar', margin, currentY)
    currentY += 20
    pdf.setFontSize(8)
    pdf.setFont('helvetica', 'normal')
    pdf.setTextColor(100, 100, 100)
    pdf.text('HANGSIX ENERGIA SOLAR', pageWidth / 2, currentY, { align: 'center' })
    currentY += 4
    pdf.text('CNPJ: 44.376.302/0001-34', pageWidth / 2, currentY, { align: 'center' })
    currentY += 4
    pdf.text('Endereço: Tv. WE29, N° 2, Cidade Nova IV, CEP: 67133-120', pageWidth / 2, currentY, { align: 'center' })
    currentY += 4
    pdf.text('Telefone: (91) 9 9253-3339 | E-mail: hangsixsolar@gmail.com', pageWidth / 2, currentY, { align: 'center' })
    const nomeArquivo = `Contrato_${nomeCliente.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`
    return { pdf, nomeArquivo }
  }

  const enviarParaClicksign = async (cliente, sendVia, signersInput, modoEnvio, anexos = []) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const signersList = (Array.isArray(signersInput) ? signersInput : []).map(s => ({
      name: String(s.name || '').trim(),
      documentation: String(s.cpf || '').replace(/\D/g, ''),
      email: String(s.email || '').trim().toLowerCase(),
      phone_number: String(s.phone || '').replace(/\D/g, '')
    }))
    if (signersList.length === 0) {
      showNotification('Adicione ao menos um signatário.', 'error')
      return
    }
    for (const s of signersList) {
      if (!s.name) { showNotification('Informe o nome de todos os signatários.', 'error'); return }
      if (s.documentation.length !== 11) { showNotification(`CPF inválido para o signatário "${s.name || 'sem nome'}" (precisa de 11 dígitos).`, 'error'); return }
      if ((sendVia === 'email' || sendVia === 'both') && (!s.email || !emailRegex.test(s.email))) { showNotification(`E-mail inválido para o signatário "${s.name}".`, 'error'); return }
      if ((sendVia === 'whatsapp' || sendVia === 'both') && (s.phone_number.length < 10 || s.phone_number.length > 11)) { showNotification(`Telefone (WhatsApp) inválido para o signatário "${s.name}" (10 ou 11 dígitos).`, 'error'); return }
    }
    const envioAnexos = modoEnvio === 'anexos'
    const arquivosValidos = Array.isArray(anexos) ? anexos.filter(f => f instanceof File && f.type === 'application/pdf') : []
    if (envioAnexos && arquivosValidos.length === 0) {
      showNotification('Selecione ao menos um documento PDF para enviar.', 'error')
      return
    }
    setSendingClicksign(true)
    setShowClicksignModal(false)
    setClienteClicksign(null)
    setClicksignEmailInput('')
    setClicksignPhoneInput('')
    setClicksignSigners([])
    try {
      let bytes
      let filename
      const nomeCliente = (cliente.nome_completo || 'Cliente').replace(/\s+/g, '_')
      const dataStr = new Date().toISOString().split('T')[0]

      if (envioAnexos) {
        const mergedPdf = await PDFDocument.create()
        for (const file of arquivosValidos) {
          const anexoBuf = await file.arrayBuffer()
          const pdfAnexo = await PDFDocument.load(anexoBuf)
          const pagesAnexo = await mergedPdf.copyPages(pdfAnexo, pdfAnexo.getPageIndices())
          pagesAnexo.forEach(p => mergedPdf.addPage(p))
        }
        const mergedBytes = await mergedPdf.save()
        bytes = new Uint8Array(mergedBytes)
        filename = `Documentos_${nomeCliente}_${dataStr}.pdf`
      } else {
        const { pdf: pdfProc } = buildProcuracaoPdf(cliente)
        const { pdf: pdfCont } = await buildContratoPdf(cliente)
        const procBuf = pdfProc.output('arraybuffer')
        const contBuf = pdfCont.output('arraybuffer')
        const pdfProcDoc = await PDFDocument.load(procBuf)
        const pdfContDoc = await PDFDocument.load(contBuf)
        const mergedPdf = await PDFDocument.create()
        const pagesProc = await mergedPdf.copyPages(pdfProcDoc, pdfProcDoc.getPageIndices())
        pagesProc.forEach(p => mergedPdf.addPage(p))
        const pagesCont = await mergedPdf.copyPages(pdfContDoc, pdfContDoc.getPageIndices())
        pagesCont.forEach(p => mergedPdf.addPage(p))
        const mergedBytes = await mergedPdf.save()
        bytes = new Uint8Array(mergedBytes)
        filename = `Procuração_e_Contrato_${nomeCliente}_${dataStr}.pdf`
      }

      const bucket = 'clicksign-uploads'
      const storagePath = `temp/${Date.now()}-${Math.random().toString(36).slice(2, 11)}.pdf`
      const blob = new Blob([bytes], { type: 'application/pdf' })
      const { error: uploadErr } = await supabase.storage.from(bucket).upload(storagePath, blob, {
        contentType: 'application/pdf',
        upsert: false
      })
      if (uploadErr) {
        console.error('Clicksign: falha ao enviar PDF para Storage', uploadErr)
        showNotification('Falha ao enviar PDF. Crie o bucket "clicksign-uploads" no Storage (Supabase) e tente novamente.', 'error')
        setSendingClicksign(false)
        return
      }

      const signersPayload = signersList.map(s => {
        const signer = { name: s.name, documentation: s.documentation }
        if (sendVia === 'email' || sendVia === 'both') signer.email = s.email
        if (sendVia === 'whatsapp' || sendVia === 'both') signer.phone_number = s.phone_number
        return signer
      })
      const result = await enviarProcuracaoParaClicksign({
        storage_path: storagePath,
        storage_bucket: bucket,
        filename,
        send_via: sendVia,
        signers: signersPayload,
        notification_sender_name: 'ConectSolar'
      })
      if (result.success) {
        try {
          await supabase.from('procuracao_clicksign_envios').insert({
            cliente_id: cliente.id,
            document_key: result.document_key || null,
            clicksign_document_id: result.document_id || null,
            signing_url: result.signing_url || null,
            send_via: sendVia
          })
          loadProcuracaoEnvios()
        } catch (e) {
          console.error('Erro ao registrar envio:', e)
        }
        setClicksignResult({ url: result.signing_url, message: result.message })
      } else {
        showNotification(result.error || 'Falha ao enviar para Clicksign.', 'error')
      }
    } catch (err) {
      console.error('Clicksign:', err)
      showNotification('Erro ao enviar procuração para assinatura: ' + (err.message || 'erro desconhecido'), 'error')
    } finally {
      setSendingClicksign(false)
    }
  }

  const formatarDataEnvio = (iso) => {
    if (!iso) return ''
    return new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
  }

  const handleBaixarDocumentoAssinado = async (cliente) => {
    const envio = enviosProcuracaoPorCliente[cliente.id]
    if (!envio?.signed_at) {
      showNotification('Só é possível baixar após a assinatura.', 'warning')
      return
    }
    if (!envio.document_key || !envio.clicksign_document_id) {
      showNotification(
        'Registro do envio à Clicksign está incompleto (falta ID do envelope ou do documento). Se o envio for antigo, pode ser necessário reenviar.',
        'error'
      )
      return
    }
    setBaixandoAssinadoClienteId(cliente.id)
    try {
      const r = await baixarPdfAssinadoClicksign({
        envelopeId: envio.document_key,
        documentId: envio.clicksign_document_id
      })
      if (!r.success) {
        showNotification(r.error || 'Não foi possível baixar o PDF assinado.', 'error')
        return
      }
      const bin = atob(r.pdf_base64)
      const arr = new Uint8Array(bin.length)
      for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i)
      const blob = new Blob([arr], { type: 'application/pdf' })
      const nomeSan = (cliente.nome_completo || 'cliente').replace(/[/\\?%*:|"<>]/g, '-').slice(0, 80)
      saveAs(blob, r.filename || `Assinado_${nomeSan}.pdf`)
      showNotification('PDF assinado baixado.', 'success')
    } catch (e) {
      console.error(e)
      showNotification(e?.message || 'Erro ao baixar o documento.', 'error')
    } finally {
      setBaixandoAssinadoClienteId(null)
    }
  }

  const openEnviarClicksign = (cliente) => {
    setClienteClicksign(cliente)
    setClicksignSendVia('whatsapp')
    setClicksignModoEnvio('anexos')
    setClicksignEmailInput((cliente.email || '').trim())
    setClicksignPhoneInput(String(cliente.telefone || '').replace(/\D/g, ''))
    setClicksignAnexos([])
    // Primeiro signatário: o próprio cliente (dados pré-preenchidos e editáveis)
    setClicksignSigners([{
      name: cliente.nome_completo || '',
      cpf: String(cliente.cpf || '').replace(/\D/g, ''),
      email: (cliente.email || '').trim(),
      phone: String(cliente.telefone || '').replace(/\D/g, '')
    }])
    if (clicksignFileInputRef.current) clicksignFileInputRef.current.value = ''
    setShowClicksignModal(true)
  }

  const addClicksignSigner = () => {
    setClicksignSigners(prev => [...prev, { name: '', cpf: '', email: '', phone: '' }])
  }

  const removeClicksignSigner = (index) => {
    setClicksignSigners(prev => prev.filter((_, i) => i !== index))
  }

  const updateClicksignSigner = (index, field, value) => {
    setClicksignSigners(prev => prev.map((s, i) => (i === index ? { ...s, [field]: value } : s)))
  }

  const closeClicksignHub = () => setClicksignHubCliente(null)

  /**
   * Ícone como os demais da coluna Ações: ✓ verde (assinado), ⏳ amarelo (enviado, aguardando), ✉️ amarelo (ainda não enviado).
   * Detalhes no title e no modal.
   */
  const renderBotaoClicksignUnificado = (c) => {
    const envio = enviosProcuracaoPorCliente[c.id]
    const assinado = !!envio?.signed_at
    const jaEnviado = !!envio && !assinado
    const dataAss = envio?.signed_at ? formatarDataEnvio(envio.signed_at) : ''
    const title = assinado
      ? (dataAss
        ? `Clicksign: assinado em ${dataAss}. Clique para baixar o PDF.`
        : 'Clicksign: documento assinado. Clique para baixar o PDF.')
      : jaEnviado
        ? `Clicksign: enviado em ${formatarDataEnvio(envio.created_at)} — aguardando assinatura. Clique para reenviar.`
        : 'Clicksign: ainda não enviado. Clique para enviar à assinatura.'

    const icon = assinado ? '✓' : jaEnviado ? '⏳' : '✉️'

    return (
      <button
        type="button"
        className={`btn btn-sm btn-cadastrar-clicksign btn-cadastrar-clicksign--icon ${assinado ? 'btn-cadastrar-clicksign--assinado' : 'btn-cadastrar-clicksign--pendente'}`}
        title={title}
        aria-label={title}
        onClick={() => setClicksignHubCliente(c)}
      >
        {icon}
      </button>
    )
  }

  const removeClicksignAnexo = (index) => {
    setClicksignAnexos(prev => prev.filter((_, i) => i !== index))
  }

  const closeClicksignModal = () => {
    setShowClicksignModal(false)
    setClienteClicksign(null)
    setClicksignEmailInput('')
    setClicksignPhoneInput('')
    setClicksignModoEnvio('anexos')
    setClicksignAnexos([])
    setClicksignSigners([])
    if (clicksignFileInputRef.current) clicksignFileInputRef.current.value = ''
  }

  const clientesFiltrados = clientes.filter(c => {
    if (filtroNome && filtroNome.trim() !== '') {
      const nome = (c.nome_completo || '').toLowerCase()
      if (!nome.includes(filtroNome.toLowerCase().trim())) return false
    }
    if (verClientesTodasEmpresas && filtroEmpresa && filtroEmpresa !== '') {
      if (c.empresa_id !== filtroEmpresa) return false
    }
    return true
  })

  return (
    <div className="clientes-ii-container" style={{ padding: '1.5rem' }}>
      <div className="clientes-ii-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem', marginBottom: '1.5rem' }}>
        <h2>📝 Cadastrar Clientes</h2>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button type="button" className="btn btn-primary" onClick={openNew}>➕ Novo cliente</button>
          {onBack && <button type="button" className="btn-back" onClick={onBack}>Voltar</button>}
        </div>
      </div>
      {/* Filtros */}
      <div className="filtros-container" style={{
        marginBottom: '1.5rem',
        padding: '1rem 1.25rem',
        background: '#f8f9fa',
        borderRadius: '12px',
        border: '1px solid #e9ecef'
      }}>
        <h3 style={{ marginBottom: '1rem', fontSize: '1rem', fontWeight: '600', color: '#495057' }}>🔍 Filtros</h3>
        <div style={{ display: 'grid', gridTemplateColumns: verClientesTodasEmpresas ? '1fr 1fr' : '1fr', gap: '1rem', alignItems: 'end' }}>
          {verClientesTodasEmpresas && (
            <div>
              <label htmlFor="filtro-empresa-cadastrar" style={{ display: 'block', marginBottom: '0.35rem', fontWeight: '500', color: '#495057', fontSize: '0.9rem' }}>Empresa</label>
              <select
                id="filtro-empresa-cadastrar"
                value={filtroEmpresa}
                onChange={(e) => setFiltroEmpresa(e.target.value)}
                style={{ width: '100%', padding: '0.5rem', border: '1px solid #ced4da', borderRadius: '6px', fontSize: '0.95rem' }}
              >
                <option value="">Todas as empresas</option>
                {empresas.map(emp => (
                  <option key={emp.id} value={emp.id}>{emp.empresa}</option>
                ))}
              </select>
            </div>
          )}
          <div>
            <label htmlFor="filtro-nome-cadastrar" style={{ display: 'block', marginBottom: '0.35rem', fontWeight: '500', color: '#495057', fontSize: '0.9rem' }}>Nome do cliente</label>
            <input
              type="text"
              id="filtro-nome-cadastrar"
              value={filtroNome}
              onChange={(e) => setFiltroNome(e.target.value)}
              placeholder="Digite o nome do cliente..."
              style={{ width: '100%', padding: '0.5rem', border: '1px solid #ced4da', borderRadius: '6px', fontSize: '0.95rem' }}
            />
          </div>
        </div>
      </div>

      {loading && <div className="loading">Carregando...</div>}
      {!loading && (
        <>
          <div className="table-container cadastrar-clientes-table-wrap">
            <div className="table-wrapper">
              <table className="clientes-table">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>CPF</th>
                    <th>Telefone</th>
                    <th>Cidade/UF</th>
                    <th>Valor</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {clientesFiltrados.length === 0 ? (
                    <tr>
                      <td colSpan={6} className="propostas-cadastro-tabela-empty">
                        {clientes.length === 0 ? 'Nenhum cliente cadastrado (venda tradicional).' : 'Nenhum cliente encontrado com os filtros aplicados.'}
                      </td>
                    </tr>
                  ) : (
                    clientesFiltrados.map(c => (
                      <tr key={c.id}>
                        <td className="cliente-nome">
                          <button
                            type="button"
                            className="btn-link-nome"
                            onClick={() => { setClienteParaVisualizar(c); setShowClienteInfoModal(true) }}
                            title="Ver informações do cliente"
                          >
                            {c.nome_completo || '–'}
                          </button>
                        </td>
                        <td className="cliente-cpf">{formatCPFDisplay(c.cpf)}</td>
                        <td>{c.telefone || '–'}</td>
                        <td>{c.cidade && c.estado ? `${c.cidade} - ${c.estado}` : '–'}</td>
                        <td>{formatCurrencyDisplay(c.valor_total)}</td>
                        <td>
                          <div className="acoes-group">
                            <button type="button" className="btn btn-sm btn-edit" title="Editar" onClick={() => openEditarOpcoes(c)}>✏️</button>
                            <button type="button" className="btn btn-sm btn-primary" title="Anexar PDFs (Unifilar, Análise de Sombramento, Vistoria)" onClick={() => setClienteParaDocumentos(c)}>📎</button>
                            <button type="button" className="btn btn-sm btn-primary" title="Gerar Procuração" onClick={() => abrirFluxoGerarDocumento(c)}>📋</button>
                            <button type="button" className="btn btn-sm btn-primary" title="Gerar Contrato (PDF ou HTML)" onClick={() => setClienteParaContrato(c)} disabled={gerandoContratoPdfId === c.id}>{gerandoContratoPdfId === c.id ? '⏳' : '📄'}</button>
                            {renderBotaoClicksignUnificado(c)}
                            <button type="button" className="btn btn-sm btn-ordem-servico" title="Criar Ordem de Serviço" onClick={() => { setClienteParaNovaOrdem(c); setShowNovaOrdemModal(true) }}>🔧</button>
                            {canExcluir && (
                              <button type="button" className="btn btn-sm btn-delete" title="Excluir" onClick={() => handleDelete(c)}>🗑️</button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="cadastrar-clientes-cards">
            {clientesFiltrados.length === 0 ? (
              <div className="cadastrar-clientes-cards-empty">
                {clientes.length === 0 ? 'Nenhum cliente cadastrado (venda tradicional).' : 'Nenhum cliente encontrado com os filtros aplicados.'}
              </div>
            ) : (
              clientesFiltrados.map(c => {
                const kit = Array.isArray(c.kit_solar_cliente) ? c.kit_solar_cliente[0] : c.kit_solar_cliente
                return (
                  <div key={c.id} className="cadastrar-clientes-card">
                    <button
                      type="button"
                      className="cadastrar-clientes-card-nome btn-link-nome"
                      onClick={() => { setClienteParaVisualizar(c); setShowClienteInfoModal(true) }}
                      title="Ver informações do cliente"
                    >
                      {c.nome_completo || '–'}
                    </button>
                    <div className="cadastrar-clientes-card-line">
                      <span>{kit?.marca_inversor || '–'}</span>
                      <span className="cadastrar-clientes-card-sep">|</span>
                      <span>{(kit?.potencia_inversor != null ? `${kit.potencia_inversor} kW` : '–')}</span>
                    </div>
                    <div className="cadastrar-clientes-card-line">
                      <span>{(kit?.quantidade_modulo != null ? `Qtd ${kit.quantidade_modulo}` : 'Qtd –')}</span>
                      <span className="cadastrar-clientes-card-sep">|</span>
                      <span>{kit?.marca_modulo || '–'}</span>
                      <span className="cadastrar-clientes-card-sep">|</span>
                      <span>{(kit?.potencia_modulo != null ? `${kit.potencia_modulo} W` : '–')}</span>
                    </div>
                    <div className="cadastrar-clientes-card-acoes">
                      <button type="button" className="btn btn-sm btn-edit" title="Editar" onClick={() => openEditarOpcoes(c)}>Editar</button>
                      <button type="button" className="btn btn-sm btn-primary" title="Anexos" onClick={() => setClienteParaDocumentos(c)}>Anexos</button>
                      <button type="button" className="btn btn-sm btn-primary" title="Gerar Procuração" onClick={() => abrirFluxoGerarDocumento(c)}>Procuração</button>
                      <button type="button" className="btn btn-sm btn-primary" title="Gerar Contrato (PDF ou HTML)" onClick={() => setClienteParaContrato(c)} disabled={gerandoContratoPdfId === c.id}>{gerandoContratoPdfId === c.id ? 'Gerando...' : 'Contrato'}</button>
                      {renderBotaoClicksignUnificado(c)}
                      <button type="button" className="btn btn-sm btn-ordem-servico" title="Criar Ordem de Serviço" onClick={() => { setClienteParaNovaOrdem(c); setShowNovaOrdemModal(true) }}>Ordem de Serviço</button>
                      {canExcluir && (
                        <button type="button" className="btn btn-sm btn-delete" title="Excluir" onClick={() => handleDelete(c)}>Lixeira</button>
                      )}
                    </div>
                  </div>
                )
              })
            )}
          </div>
        </>
      )}
      {gerandoContratoPdfId && (
        <div className="form-overlay" style={{ zIndex: 3000 }}>
          <div className="form-modal" style={{ maxWidth: '360px', textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
            <div style={{ padding: '36px 28px' }}>
              <div className="contrato-pdf-spinner" style={{ margin: '0 auto 18px' }} />
              <h3 style={{ margin: '0 0 8px 0', color: '#333', fontSize: '18px', fontWeight: 600 }}>Gerando contrato...</h3>
              <p style={{ margin: 0, color: '#666', fontSize: '13px' }}>Montando o contrato. Isso pode levar alguns instantes.</p>
              <p style={{ margin: '10px 0 0 0', color: '#999', fontSize: '12px', fontStyle: 'italic' }}>Por favor, aguarde.</p>
            </div>
          </div>
        </div>
      )}
      {clienteParaContrato && !gerandoContratoPdfId && (
        <div className="form-overlay" onClick={() => setClienteParaContrato(null)}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '460px' }}>
            <div className="modal-header">
              <h3>Gerar Contrato</h3>
              <button type="button" onClick={() => setClienteParaContrato(null)} className="close-button">×</button>
            </div>
            <p style={{ marginBottom: '1rem', color: '#495057' }}>
              <strong>Cliente:</strong> {clienteParaContrato.nome_completo || '–'}
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => gerarContratoPdfCliente(clienteParaContrato)}
              >
                📄 Baixar PDF
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => gerarContratoHtmlCliente(clienteParaContrato)}
              >
                📝 Baixar HTML (editável)
              </button>
            </div>
            <p style={{ marginTop: '1rem', fontSize: '0.85rem', color: '#6c757d' }}>
              O HTML tem o mesmo conteúdo do PDF e pode ser aberto no navegador ou no Word para edição.
            </p>
          </div>
        </div>
      )}
      {clienteParaDocumentos && (
        <DocumentosCliente
          cliente={clienteParaDocumentos}
          onClose={() => setClienteParaDocumentos(null)}
        />
      )}
      {showNovaOrdemModal && clienteParaNovaOrdem && (
        <NovaOrdemServicoModal
          open={showNovaOrdemModal}
          onClose={() => { setShowNovaOrdemModal(false); setClienteParaNovaOrdem(null) }}
          initialCliente={clienteParaNovaOrdem}
          userRole={userRole}
          userEmpresa={userEmpresa}
          userId={userId}
          onSaved={() => { setShowNovaOrdemModal(false); setClienteParaNovaOrdem(null) }}
        />
      )}

      {/* Modal: Opções ao clicar em Editar */}
      {showEditarOpcoesModal && clienteParaEditarOpcoes && (
        <div className="form-overlay" onClick={() => { setShowEditarOpcoesModal(false); setClienteParaEditarOpcoes(null) }}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '420px' }}>
            <div className="modal-header">
              <h3>Editar cliente</h3>
              <button type="button" onClick={() => { setShowEditarOpcoesModal(false); setClienteParaEditarOpcoes(null) }} className="close-button">×</button>
            </div>
            <p style={{ marginBottom: '1rem', color: '#495057' }}>
              <strong>Cliente:</strong> {clienteParaEditarOpcoes.nome_completo}
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <button type="button" className="btn btn-primary" onClick={escolherEditarCliente}>
                ✏️ Editar Cliente
              </button>
              <button type="button" className="btn btn-secondary" onClick={escolherAtribuirDados}>
                📋 Atribuir Dados
              </button>
            </div>
            <p style={{ marginTop: '1rem', fontSize: '0.85rem', color: '#6c757d' }}>
              Atribuir Dados permite adicionar ou alterar CPF e RG do cliente.
            </p>
          </div>
        </div>
      )}

      {/* Modal: Atribuir Dados (CPF e RG) */}
      {showAtribuirDadosModal && clienteParaAtribuirDados && (
        <div className="form-overlay" onClick={() => { setShowAtribuirDadosModal(false); setClienteParaAtribuirDados(null) }}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '420px' }}>
            <div className="modal-header">
              <h3>Atribuir Dados</h3>
              <button type="button" onClick={() => { setShowAtribuirDadosModal(false); setClienteParaAtribuirDados(null) }} className="close-button">×</button>
            </div>
            <p style={{ marginBottom: '1rem', color: '#495057' }}>
              <strong>Cliente:</strong> {clienteParaAtribuirDados.nome_completo}
            </p>
            <form onSubmit={handleAtribuirDadosSubmit}>
              <div className="form-group" style={{ marginBottom: '1rem' }}>
                <label htmlFor="atribuir-cpf" className="form-label">CPF *</label>
                <input
                  type="text"
                  id="atribuir-cpf"
                  className="form-control"
                  value={atribuirDadosForm.cpf}
                  onChange={(e) => setAtribuirDadosForm(prev => ({ ...prev, cpf: e.target.value.replace(/\D/g, '') }))}
                  placeholder="Somente números (11 dígitos)"
                  maxLength={11}
                />
              </div>
              <div className="form-group" style={{ marginBottom: '1rem' }}>
                <label htmlFor="atribuir-rg" className="form-label">RG</label>
                <input
                  type="text"
                  id="atribuir-rg"
                  className="form-control"
                  value={atribuirDadosForm.rg}
                  onChange={(e) => setAtribuirDadosForm(prev => ({ ...prev, rg: e.target.value }))}
                  placeholder="Número do RG"
                />
              </div>
              <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1.25rem' }}>
                <button type="button" className="btn btn-secondary" onClick={() => { setShowAtribuirDadosModal(false); setClienteParaAtribuirDados(null) }}>
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary" disabled={savingAtribuirDados}>
                  {savingAtribuirDados ? 'Salvando...' : 'Salvar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showDocumentoLxpModal && clienteDocumentoLxp && (
        <div className="form-overlay" onClick={fecharDocumentoLxpModal}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '460px' }}>
            <div className="modal-header">
              <h3>Gerar Documento</h3>
              <button type="button" onClick={fecharDocumentoLxpModal} className="close-button" disabled={gerandoContratoLxp}>×</button>
            </div>
            <p style={{ marginBottom: '1rem', color: '#495057' }}>
              <strong>Cliente:</strong> {clienteDocumentoLxp.nome_completo || '–'}
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  const cli = clienteDocumentoLxp
                  fecharDocumentoLxpModal()
                  abrirModalProcurador(cli)
                }}
              >
                📋 Gerar Procuração
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setShowDocumentoLxpModal(false)
                  setShowValorContratoLxpModal(true)
                }}
              >
                📄 Gerar Contrato
              </button>
            </div>
          </div>
        </div>
      )}

      {showValorContratoLxpModal && clienteDocumentoLxp && (
        <div className="form-overlay" onClick={fecharValorContratoLxpModal}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '430px' }}>
            <div className="modal-header">
              <h3>Valor do contrato</h3>
              <button type="button" onClick={fecharValorContratoLxpModal} className="close-button" disabled={gerandoContratoLxp}>×</button>
            </div>
            <p style={{ marginBottom: '1rem', color: '#495057' }}>
              <strong>Cliente:</strong> {clienteDocumentoLxp.nome_completo || '–'}
            </p>
            <label htmlFor="valor-contrato-lxp" className="form-label">Valor do contrato (R$)</label>
            <input
              id="valor-contrato-lxp"
              type="text"
              className="form-control"
              value={valorContratoLxpInput}
              onChange={(e) => setValorContratoLxpInput(formatCurrencyInput(e.target.value))}
              placeholder="Ex.: 35.000,00"
              disabled={gerandoContratoLxp}
            />
            <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem' }}>
              <button
                type="button"
                className="btn btn-secondary"
                style={{ flex: 1 }}
                onClick={() => {
                  setShowValorContratoLxpModal(false)
                  setShowDocumentoLxpModal(true)
                }}
                disabled={gerandoContratoLxp}
              >
                Voltar
              </button>
              <button
                type="button"
                className="btn btn-primary"
                style={{ flex: 1 }}
                onClick={() => {
                  const valorNumero = parseCurrencyInput(valorContratoLxpInput)
                  if (!valorNumero || valorNumero <= 0) {
                    showNotification('Informe um valor válido para continuar.', 'error')
                    return
                  }
                  gerarContratoLxpDocx(clienteDocumentoLxp, valorContratoLxpInput)
                }}
                disabled={gerandoContratoLxp}
              >
                {gerandoContratoLxp ? 'Gerando...' : 'Confirmar e gerar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal hub: opções Clicksign (baixar assinado OU enviar/reenviar) */}
      {clicksignHubCliente && (
        <div className="form-overlay" onClick={closeClicksignHub}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '440px' }}>
            <div className="modal-header">
              <h3>✉️ Assinatura (Clicksign)</h3>
              <button type="button" className="close-button" onClick={closeClicksignHub} aria-label="Fechar">×</button>
            </div>
            <p style={{ marginBottom: '1rem', color: '#495057' }}>
              <strong>Cliente:</strong> {clicksignHubCliente.nome_completo}
            </p>
            {(() => {
              const c = clicksignHubCliente
              const envio = enviosProcuracaoPorCliente[c.id]
              const assinado = !!envio?.signed_at
              const jaEnviado = !!envio && !assinado
              if (assinado) {
                const dataAss = envio?.signed_at ? formatarDataEnvio(envio.signed_at) : ''
                return (
                  <>
                    <div className="cadastrar-clicksign-hub-banner cadastrar-clicksign-hub-banner--assinado">
                      ✓ Documento assinado{dataAss ? ` em ${dataAss}` : ''}.
                    </div>
                    <div className="cadastrar-clicksign-hub-acoes" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => handleBaixarDocumentoAssinado(c)}
                        disabled={baixandoAssinadoClienteId === c.id}
                      >
                        {baixandoAssinadoClienteId === c.id ? 'Baixando…' : '⬇️ Baixar PDF assinado'}
                      </button>
                      <button
                        type="button"
                        className="btn btn-cadastrar-clicksign btn-cadastrar-clicksign--pendente"
                        style={{ padding: '0.55rem 1rem', fontSize: '0.95rem', width: '100%' }}
                        disabled={sendingClicksign}
                        onClick={() => {
                          closeClicksignHub()
                          openEnviarClicksign(c)
                        }}
                      >
                        ✉️ Enviar novo documento para assinatura
                      </button>
                    </div>
                  </>
                )
              }
              return (
                <>
                  <div className="cadastrar-clicksign-hub-banner cadastrar-clicksign-hub-banner--pendente">
                    {jaEnviado
                      ? `⏳ Aguardando assinatura. Enviado em ${formatarDataEnvio(envio.created_at)}.`
                      : '⏳ Nenhum documento enviado para assinatura ainda.'}
                  </div>
                  <div className="cadastrar-clicksign-hub-acoes">
                    <button
                      type="button"
                      className="btn btn-cadastrar-clicksign btn-cadastrar-clicksign--pendente"
                      style={{ padding: '0.55rem 1rem', fontSize: '0.95rem', width: '100%' }}
                      disabled={sendingClicksign}
                      onClick={() => {
                        closeClicksignHub()
                        openEnviarClicksign(c)
                      }}
                    >
                      {jaEnviado ? '✉️ Reenviar para assinatura' : '✉️ Enviar para assinatura'}
                    </button>
                  </div>
                </>
              )
            })()}
            <div style={{ marginTop: '1.1rem' }}>
              <button type="button" className="btn btn-secondary w-100" onClick={closeClicksignHub}>Fechar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Enviar procuração para assinatura (Clicksign) – igual Gestão de Clientes */}
      {showClicksignModal && clienteClicksign && (
        <div className="form-overlay" onClick={closeClicksignModal}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '440px' }}>
            <div className="modal-header">
              <h3>✉️ Enviar documento para assinatura</h3>
              <button type="button" className="close-button" onClick={closeClicksignModal}>×</button>
            </div>
            <p style={{ marginBottom: '1rem', color: '#495057' }}>
              <strong>Cliente:</strong> {clienteClicksign.nome_completo}
            </p>
            {enviosProcuracaoPorCliente[clienteClicksign.id] && (
              <p style={{ marginBottom: '1rem', fontSize: '0.9rem', color: '#0d6efd' }}>
                ✓ Já enviado em {formatarDataEnvio(enviosProcuracaoPorCliente[clienteClicksign.id].created_at)}. Deseja reenviar?
              </p>
            )}
            <div className="mb-3">
              <label className="form-label">📎 Anexar documentos (PDF)</label>
              <p style={{ fontSize: '0.85rem', color: '#6c757d', marginBottom: '0.5rem' }}>Selecione um ou mais PDFs. Eles serão mesclados na ordem e enviados para assinatura.</p>
              <input
                ref={clicksignFileInputRef}
                type="file"
                accept="application/pdf"
                multiple
                className="form-control form-control-sm"
                onChange={(e) => {
                  const files = e.target.files ? Array.from(e.target.files) : []
                  setClicksignAnexos(prev => [...prev, ...files])
                }}
              />
              {clicksignAnexos.length > 0 ? (
                <ul style={{ marginTop: '0.5rem', marginBottom: 0, paddingLeft: '1.25rem', fontSize: '0.9rem' }}>
                  {clicksignAnexos.map((file, index) => (
                    <li key={`${file.name}-${index}`} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                      <span title={file.name} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>{file.name}</span>
                      <button type="button" className="btn btn-sm btn-outline-danger" style={{ padding: '0.15rem 0.4rem', fontSize: '0.8rem' }} onClick={() => removeClicksignAnexo(index)}>Remover</button>
                    </li>
                  ))}
                </ul>
              ) : (
                <p style={{ fontSize: '0.85rem', color: '#dc3545', marginTop: '0.35rem', marginBottom: 0 }}>É necessário anexar ao menos um PDF.</p>
              )}
            </div>
            <p style={{ marginBottom: '1rem', fontSize: '0.9rem', color: '#6c757d' }}>Como o link será enviado ao signatário?</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '1rem' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', cursor: 'pointer' }}>
                <input type="radio" name="clicksign-send-via-cad" value="email" checked={clicksignSendVia === 'email'} onChange={() => setClicksignSendVia('email')} />
                <span>📧 E-mail</span>
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', cursor: 'pointer' }}>
                <input type="radio" name="clicksign-send-via-cad" value="whatsapp" checked={clicksignSendVia === 'whatsapp'} onChange={() => setClicksignSendVia('whatsapp')} />
                <span>📱 WhatsApp</span>
              </label>
            </div>
            <div className="mb-3">
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                <label className="form-label" style={{ marginBottom: 0 }}>✍️ Signatários</label>
                <button type="button" className="btn btn-sm btn-outline-primary" style={{ fontSize: '0.8rem', padding: '2px 10px' }} onClick={addClicksignSigner}>+ Adicionar signatário</button>
              </div>
              <p style={{ fontSize: '0.85rem', color: '#6c757d', marginBottom: '0.75rem' }}>
                Todas as pessoas abaixo assinarão o mesmo documento. Cada uma receberá o link {clicksignSendVia === 'whatsapp' ? 'por WhatsApp' : 'por e-mail'}.
              </p>
              {clicksignSigners.map((s, index) => (
                <div key={index} style={{ border: '1px solid #dee2e6', borderRadius: '8px', padding: '0.75rem', marginBottom: '0.75rem', background: '#f8f9fa' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                    <strong style={{ fontSize: '0.9rem', color: '#495057' }}>
                      Signatário {index + 1}{index === 0 ? ' (cliente)' : ''}
                    </strong>
                    {clicksignSigners.length > 1 && (
                      <button type="button" className="btn btn-sm btn-outline-danger" style={{ fontSize: '0.75rem', padding: '2px 8px' }} onClick={() => removeClicksignSigner(index)}>Remover</button>
                    )}
                  </div>
                  <div style={{ display: 'grid', gap: '0.5rem' }}>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Nome completo"
                      value={s.name}
                      onChange={(e) => updateClicksignSigner(index, 'name', e.target.value)}
                    />
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="CPF (somente números)"
                      value={s.cpf}
                      maxLength={11}
                      onChange={(e) => updateClicksignSigner(index, 'cpf', e.target.value.replace(/\D/g, ''))}
                    />
                    {clicksignSendVia !== 'whatsapp' && (
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        placeholder="E-mail"
                        value={s.email}
                        onChange={(e) => updateClicksignSigner(index, 'email', e.target.value)}
                      />
                    )}
                    {clicksignSendVia === 'whatsapp' && (
                      <input
                        type="tel"
                        className="form-control form-control-sm"
                        placeholder="Telefone WhatsApp (DDD + número)"
                        value={s.phone}
                        maxLength={11}
                        onChange={(e) => updateClicksignSigner(index, 'phone', e.target.value.replace(/\D/g, ''))}
                      />
                    )}
                  </div>
                </div>
              ))}
              {clicksignSigners.length === 0 && (
                <p style={{ fontSize: '0.85rem', color: '#dc3545', marginBottom: 0 }}>Adicione ao menos um signatário.</p>
              )}
            </div>
            <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1.25rem' }}>
              <button type="button" className="btn btn-secondary" onClick={closeClicksignModal}>Cancelar</button>
              <button
                type="button"
                className="btn btn-primary"
                disabled={sendingClicksign || clicksignAnexos.length === 0 || clicksignSigners.length === 0}
                onClick={() => enviarParaClicksign(clienteClicksign, clicksignSendVia, clicksignSigners, 'anexos', clicksignAnexos)}
              >
                Enviar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Enviando (spinner) */}
      {sendingClicksign && (
        <div className="form-overlay" style={{ pointerEvents: 'auto' }}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '320px', textAlign: 'center' }}>
            <div style={{ padding: '2rem' }}>
              <div style={{ marginBottom: '1rem' }}>
                <span className="spinner-border text-primary" role="status" aria-hidden="true" style={{ width: '3rem', height: '3rem' }} />
              </div>
              <p style={{ margin: 0, fontSize: '1rem', color: '#495057' }}>Enviando para assinatura…</p>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Sucesso Clicksign (link de assinatura) */}
      {clicksignResult && (
        <div className="form-overlay" onClick={() => setClicksignResult(null)}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '480px' }}>
            <div className="modal-header">
              <h3>✅ Procuração enviada para assinatura</h3>
              <button type="button" className="close-button" onClick={() => setClicksignResult(null)}>×</button>
            </div>
            <p style={{ marginBottom: '1rem', color: '#495057' }}>{clicksignResult.message}</p>
            {clicksignResult.url && (
              <>
                <p style={{ marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: '600' }}>Link para o cliente assinar:</p>
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
                  <input
                    type="text"
                    readOnly
                    value={clicksignResult.url}
                    className="form-control"
                    style={{ flex: '1', minWidth: '200px', fontSize: '0.85rem' }}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={() => {
                      navigator.clipboard.writeText(clicksignResult.url)
                      showNotification('Link copiado!', 'success')
                    }}
                  >
                    Copiar link
                  </button>
                </div>
              </>
            )}
            <div style={{ marginTop: '1.25rem' }}>
              <button type="button" className="btn btn-primary" onClick={() => setClicksignResult(null)}>Fechar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Assinatura realizada com sucesso (Realtime) */}
      {assinaturaSucessoModal.show && (
        <div className="form-overlay" onClick={() => setAssinaturaSucessoModal({ show: false, clienteNome: '' })}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px' }}>
            <div className="modal-header">
              <h3>✅ Assinatura realizada com sucesso</h3>
              <button type="button" className="close-button" onClick={() => setAssinaturaSucessoModal({ show: false, clienteNome: '' })} title="Fechar">×</button>
            </div>
            <p style={{ marginBottom: 0, color: '#495057', fontSize: '1rem', padding: '0 1.25rem' }}>
              O documento de <strong>{assinaturaSucessoModal.clienteNome}</strong> foi assinado com sucesso.
            </p>
            <div style={{ padding: '1rem 1.25rem' }}>
              <button type="button" className="btn btn-primary" onClick={() => setAssinaturaSucessoModal({ show: false, clienteNome: '' })}>OK</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Visualizar Cliente */}
      {showClienteInfoModal && clienteParaVisualizar && (
        <div className="form-overlay" onClick={() => { setShowClienteInfoModal(false); setClienteParaVisualizar(null) }}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '560px' }}>
            <div className="modal-header">
              <h3>👤 Dados do Cliente</h3>
              <button type="button" className="close-button" onClick={() => { setShowClienteInfoModal(false); setClienteParaVisualizar(null) }}>×</button>
            </div>
            <div style={{ padding: '1.25rem' }}>
              <div style={{ display: 'grid', gap: '0.75rem' }}>
                <div><strong>Nome:</strong> {clienteParaVisualizar.nome_completo || '–'}</div>
                <div><strong>CPF:</strong> {formatCPFDisplay(clienteParaVisualizar.cpf)}</div>
                <div><strong>RG:</strong> {clienteParaVisualizar.rg || '–'}</div>
                <div><strong>Telefone:</strong> {clienteParaVisualizar.telefone || '–'}</div>
                {verClientesTodasEmpresas && (
                  <div><strong>Empresa:</strong> {nomeEmpresaPorId(clienteParaVisualizar.empresa_id)}</div>
                )}
                <div><strong>Endereço:</strong> {formatarEndereco(clienteParaVisualizar)}</div>
                {clienteParaVisualizar.link_localizacao && (
                  <div>
                    <strong>Link da localização:</strong>{' '}
                    <a href={clienteParaVisualizar.link_localizacao} target="_blank" rel="noopener noreferrer">Abrir no mapa</a>
                  </div>
                )}
                {clienteParaVisualizar.foto_fachada && (
                  <div>
                    <strong>Foto da fachada:</strong>
                    <div style={{ marginTop: '0.5rem' }}>
                      <a href={clienteParaVisualizar.foto_fachada} target="_blank" rel="noopener noreferrer">
                        <img src={clienteParaVisualizar.foto_fachada} alt="Fachada" style={{ maxWidth: '200px', maxHeight: '150px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #dee2e6' }} />
                      </a>
                    </div>
                  </div>
                )}
                {(() => {
                  const kit = Array.isArray(clienteParaVisualizar.kit_solar_cliente) ? clienteParaVisualizar.kit_solar_cliente[0] : clienteParaVisualizar.kit_solar_cliente
                  if (!kit) return null
                  return (
                    <div style={{ marginTop: '0.5rem', padding: '0.75rem', background: '#f8f9fa', borderRadius: '8px' }}>
                      <strong>☀️ Kit Solar</strong>
                      <div style={{ marginTop: '0.35rem', fontSize: '0.95rem' }}>
                        Inversor: {kit.marca_inversor || '–'} {kit.potencia_inversor != null ? `(${kit.potencia_inversor} kW)` : ''} {kit.quantidade_inversor != null ? `Qtd: ${kit.quantidade_inversor}` : ''}
                      </div>
                      <div style={{ marginTop: '0.25rem', fontSize: '0.95rem' }}>
                        Módulo: {kit.marca_modulo || '–'} {kit.potencia_modulo != null ? `(${kit.potencia_modulo} W)` : ''} {kit.quantidade_modulo != null ? `Qtd: ${kit.quantidade_modulo}` : ''}
                      </div>
                    </div>
                  )
                })()}
                <div><strong>Valor:</strong> {formatCurrencyDisplay(clienteParaVisualizar.valor_total)}</div>
              </div>
              <div style={{ marginTop: '1.25rem', display: 'flex', justifyContent: 'flex-end' }}>
                <button type="button" className="btn btn-secondary" onClick={() => { setShowClienteInfoModal(false); setClienteParaVisualizar(null) }}>
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {msg.text && (
        <div className="form-overlay" onClick={() => setMsg({ text: '', type: '' })}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px' }}>
            <div className="modal-header">
              <h3>{msg.type === 'success' ? 'Sucesso' : msg.type === 'error' ? 'Erro' : 'Aviso'}</h3>
              <button type="button" className="close-button" onClick={() => setMsg({ text: '', type: '' })}>×</button>
            </div>
            <p style={{ padding: '1rem', margin: 0 }}>{msg.text}</p>
            <div style={{ padding: '0 1rem 1rem', textAlign: 'right' }}>
              <button type="button" className="btn btn-primary" onClick={() => setMsg({ text: '', type: '' })}>OK</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default CadastrarClientes
